/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminAUsersIndexRouteImport } from './routes/_admin/a/users/index'
import { Route as AdminATenantsIndexRouteImport } from './routes/_admin/a/tenants/index'
import { Route as AdminATagsIndexRouteImport } from './routes/_admin/a/tags/index'
import { Route as AdminASubnetsIndexRouteImport } from './routes/_admin/a/subnets/index'
import { Route as AdminASettingsIndexRouteImport } from './routes/_admin/a/settings/index'
import { Route as AdminARulesetsIndexRouteImport } from './routes/_admin/a/rulesets/index'
import { Route as AdminAProfileIndexRouteImport } from './routes/_admin/a/profile/index'
import { Route as AdminAPreauthkeysIndexRouteImport } from './routes/_admin/a/preauthkeys/index'
import { Route as AdminAPluginsIndexRouteImport } from './routes/_admin/a/plugins/index'
import { Route as AdminALogsIndexRouteImport } from './routes/_admin/a/logs/index'
import { Route as AdminAGroupsIndexRouteImport } from './routes/_admin/a/groups/index'
import { Route as AdminAExitnodesIndexRouteImport } from './routes/_admin/a/exitnodes/index'
import { Route as AdminADnsIndexRouteImport } from './routes/_admin/a/dns/index'
import { Route as AdminADevicesIndexRouteImport } from './routes/_admin/a/devices/index'
import { Route as AdminADevicegroupsIndexRouteImport } from './routes/_admin/a/devicegroups/index'
import { Route as AdminADashboardIndexRouteImport } from './routes/_admin/a/dashboard/index'
import { Route as AdminAChangelogIndexRouteImport } from './routes/_admin/a/changelog/index'
import { Route as AdminAAccountsIndexRouteImport } from './routes/_admin/a/accounts/index'
import { Route as AdminAAccessVisualizationIndexRouteImport } from './routes/_admin/a/access-visualization/index'
import { Route as StaticSLoginServerErrorRouteImport } from './routes/_static/s/login/server-error'
import { Route as StaticSLoginOutdatedRouteImport } from './routes/_static/s/login/outdated'
import { Route as StaticSLoginInvalidCsrfRouteImport } from './routes/_static/s/login/invalid-csrf'
import { Route as StaticSLoginDisabledRouteImport } from './routes/_static/s/login/disabled'
import { Route as AdminAUsersInviteRouteImport } from './routes/_admin/a/users/invite'
import { Route as AdminATenantsCreateRouteImport } from './routes/_admin/a/tenants/create'
import { Route as AdminASubnetsSubnetsRouteImport } from './routes/_admin/a/subnets/_subnets'
import { Route as AdminASettingsSettingsRouteImport } from './routes/_admin/a/settings/_settings'
import { Route as AdminAGroupsCreateLocalRouteImport } from './routes/_admin/a/groups/create-local'
import { Route as AdminAGroupsGroupsRouteImport } from './routes/_admin/a/groups/_groups'
import { Route as AdminAExitnodesExitnodesRouteImport } from './routes/_admin/a/exitnodes/_exitnodes'
import { Route as AdminADnsDnsRouteImport } from './routes/_admin/a/dns/_dns'
import { Route as AdminADevicesCreateServerRouteImport } from './routes/_admin/a/devices/create-server'
import { Route as AdminAPluginsPluginIdIndexRouteImport } from './routes/_admin/a/plugins/$pluginId/index'
import { Route as AdminAUsersUserIdUserRouteImport } from './routes/_admin/a/users/$userId/_user'
import { Route as AdminATenantsTenantIdDeletePreviewRouteImport } from './routes/_admin/a/tenants/$tenantId/delete-preview'
import { Route as AdminATenantsTenantIdTenantRouteImport } from './routes/_admin/a/tenants/$tenantId/_tenant'
import { Route as AdminATagsTagIdTagsRouteImport } from './routes/_admin/a/tags/$tagId/_tags'
import { Route as AdminASubnetsSubnetsPendingRouteImport } from './routes/_admin/a/subnets/_subnets/pending'
import { Route as AdminASubnetsSubnetsApprovedRouteImport } from './routes/_admin/a/subnets/_subnets/approved'
import { Route as AdminASubnetsSubnetIdSubnetRouteImport } from './routes/_admin/a/subnets/$subnetId/_subnet'
import { Route as AdminASettingsSettingsLocalRouteImport } from './routes/_admin/a/settings/_settings/local'
import { Route as AdminASettingsSettingsGeneralRouteImport } from './routes/_admin/a/settings/_settings/general'
import { Route as AdminASettingsSettingsEphemeralRouteImport } from './routes/_admin/a/settings/_settings/ephemeral'
import { Route as AdminARulesetsRulesetIdRulesetRouteImport } from './routes/_admin/a/rulesets/$rulesetId/_ruleset'
import { Route as AdminAPluginsPluginIdPluginRouteImport } from './routes/_admin/a/plugins/$pluginId/_plugin'
import { Route as AdminAGroupsGroupsScimRouteImport } from './routes/_admin/a/groups/_groups/scim'
import { Route as AdminAGroupsGroupsLocalRouteImport } from './routes/_admin/a/groups/_groups/local'
import { Route as AdminAGroupsGroupsLdapRouteImport } from './routes/_admin/a/groups/_groups/ldap'
import { Route as AdminAGroupsGroupIdGroupRouteImport } from './routes/_admin/a/groups/$groupId/_group'
import { Route as AdminAExitnodesExitnodesPendingRouteImport } from './routes/_admin/a/exitnodes/_exitnodes/pending'
import { Route as AdminAExitnodesExitnodesApprovedRouteImport } from './routes/_admin/a/exitnodes/_exitnodes/approved'
import { Route as AdminADnsDnsSplitRouteImport } from './routes/_admin/a/dns/_dns/split'
import { Route as AdminADnsDnsSearchDomainsRouteImport } from './routes/_admin/a/dns/_dns/search-domains'
import { Route as AdminADnsDnsGlobalRouteImport } from './routes/_admin/a/dns/_dns/global'
import { Route as AdminADevicesDeviceIdDeviceRouteImport } from './routes/_admin/a/devices/$deviceId/_device'
import { Route as AdminADevicegroupsDeviceGroupIdDevicegroupsRouteImport } from './routes/_admin/a/devicegroups/$deviceGroupId/_devicegroups'
import { Route as AdminASettingsSettingsOidcIndexRouteImport } from './routes/_admin/a/settings/_settings/oidc/index'
import { Route as AdminADnsDnsExtraRecordsIndexRouteImport } from './routes/_admin/a/dns/_dns/extra-records/index'
import { Route as AdminAUsersUserIdUserInvitationRouteImport } from './routes/_admin/a/users/$userId/_user/invitation'
import { Route as AdminAUsersUserIdUserGeneralRouteImport } from './routes/_admin/a/users/$userId/_user/general'
import { Route as AdminAUsersUserIdUserAccessHistoryRouteImport } from './routes/_admin/a/users/$userId/_user/access-history'
import { Route as AdminATenantsTenantIdTenantSplitDnsRouteImport } from './routes/_admin/a/tenants/$tenantId/_tenant/split-dns'
import { Route as AdminATenantsTenantIdTenantSearchDomainRouteImport } from './routes/_admin/a/tenants/$tenantId/_tenant/search-domain'
import { Route as AdminATenantsTenantIdTenantScimRouteImport } from './routes/_admin/a/tenants/$tenantId/_tenant/scim'
import { Route as AdminATenantsTenantIdTenantOidcRouteImport } from './routes/_admin/a/tenants/$tenantId/_tenant/oidc'
import { Route as AdminATenantsTenantIdTenantLdapRouteImport } from './routes/_admin/a/tenants/$tenantId/_tenant/ldap'
import { Route as AdminATenantsTenantIdTenantGeneralRouteImport } from './routes/_admin/a/tenants/$tenantId/_tenant/general'
import { Route as AdminATagsTagIdTagsOutboundAclsRouteImport } from './routes/_admin/a/tags/$tagId/_tags/outbound-acls'
import { Route as AdminATagsTagIdTagsInboundAclsRouteImport } from './routes/_admin/a/tags/$tagId/_tags/inbound-acls'
import { Route as AdminATagsTagIdTagsAssociatedRouteImport } from './routes/_admin/a/tags/$tagId/_tags/associated'
import { Route as AdminASubnetsSubnetIdSubnetRoutersRouteImport } from './routes/_admin/a/subnets/$subnetId/_subnet/routers'
import { Route as AdminASubnetsSubnetIdSubnetOutboundAclsRouteImport } from './routes/_admin/a/subnets/$subnetId/_subnet/outbound-acls'
import { Route as AdminASubnetsSubnetIdSubnetInboundAclsRouteImport } from './routes/_admin/a/subnets/$subnetId/_subnet/inbound-acls'
import { Route as AdminARulesetsRulesetIdRulesetRulesRouteImport } from './routes/_admin/a/rulesets/$rulesetId/_ruleset/rules'
import { Route as AdminARulesetsRulesetIdRulesetInstancesRouteImport } from './routes/_admin/a/rulesets/$rulesetId/_ruleset/instances'
import { Route as AdminAPluginsPluginIdPluginRulesetsRouteImport } from './routes/_admin/a/plugins/$pluginId/_plugin/rulesets'
import { Route as AdminAGroupsGroupIdGroupOutboundAclsRouteImport } from './routes/_admin/a/groups/$groupId/_group/outbound-acls'
import { Route as AdminAGroupsGroupIdGroupInboundAclsRouteImport } from './routes/_admin/a/groups/$groupId/_group/inbound-acls'
import { Route as AdminAGroupsGroupIdGroupGeneralRouteImport } from './routes/_admin/a/groups/$groupId/_group/general'
import { Route as AdminADnsDnsExtraRecordsCreateNewDomainRouteImport } from './routes/_admin/a/dns/_dns/extra-records/create-new-domain'
import { Route as AdminADevicesDeviceIdDeviceOutboundAclsRouteImport } from './routes/_admin/a/devices/$deviceId/_device/outbound-acls'
import { Route as AdminADevicesDeviceIdDeviceInboundAclsRouteImport } from './routes/_admin/a/devices/$deviceId/_device/inbound-acls'
import { Route as AdminADevicesDeviceIdDeviceGeneralRouteImport } from './routes/_admin/a/devices/$deviceId/_device/general'
import { Route as AdminADevicesDeviceIdDeviceDebugRouteImport } from './routes/_admin/a/devices/$deviceId/_device/debug'
import { Route as AdminADevicegroupsDeviceGroupIdDevicegroupsOutboundAclsRouteImport } from './routes/_admin/a/devicegroups/$deviceGroupId/_devicegroups/outbound-acls'
import { Route as AdminADevicegroupsDeviceGroupIdDevicegroupsInboundAclsRouteImport } from './routes/_admin/a/devicegroups/$deviceGroupId/_devicegroups/inbound-acls'
import { Route as AdminADevicegroupsDeviceGroupIdDevicegroupsAssociatedRouteImport } from './routes/_admin/a/devicegroups/$deviceGroupId/_devicegroups/associated'
import { Route as AdminASettingsSettingsOidcProviderIdIndexRouteImport } from './routes/_admin/a/settings/_settings/oidc/$providerId/index'

const StaticLazyRouteImport = createFileRoute('/_static')()
const AdminLazyRouteImport = createFileRoute('/_admin')()

const StaticLazyRoute = StaticLazyRouteImport.update({
  id: '/_static',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/_static.lazy').then((d) => d.Route))
const AdminLazyRoute = AdminLazyRouteImport.update({
  id: '/_admin',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/_admin.lazy').then((d) => d.Route))
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAUsersIndexRoute = AdminAUsersIndexRouteImport.update({
  id: '/a/users/',
  path: '/a/users/',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminATenantsIndexRoute = AdminATenantsIndexRouteImport.update({
  id: '/a/tenants/',
  path: '/a/tenants/',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminATagsIndexRoute = AdminATagsIndexRouteImport.update({
  id: '/a/tags/',
  path: '/a/tags/',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminASubnetsIndexRoute = AdminASubnetsIndexRouteImport.update({
  id: '/a/subnets/',
  path: '/a/subnets/',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminASettingsIndexRoute = AdminASettingsIndexRouteImport.update({
  id: '/a/settings/',
  path: '/a/settings/',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminARulesetsIndexRoute = AdminARulesetsIndexRouteImport.update({
  id: '/a/rulesets/',
  path: '/a/rulesets/',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminAProfileIndexRoute = AdminAProfileIndexRouteImport.update({
  id: '/a/profile/',
  path: '/a/profile/',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminAPreauthkeysIndexRoute = AdminAPreauthkeysIndexRouteImport.update({
  id: '/a/preauthkeys/',
  path: '/a/preauthkeys/',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminAPluginsIndexRoute = AdminAPluginsIndexRouteImport.update({
  id: '/a/plugins/',
  path: '/a/plugins/',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminALogsIndexRoute = AdminALogsIndexRouteImport.update({
  id: '/a/logs/',
  path: '/a/logs/',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminAGroupsIndexRoute = AdminAGroupsIndexRouteImport.update({
  id: '/a/groups/',
  path: '/a/groups/',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminAExitnodesIndexRoute = AdminAExitnodesIndexRouteImport.update({
  id: '/a/exitnodes/',
  path: '/a/exitnodes/',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminADnsIndexRoute = AdminADnsIndexRouteImport.update({
  id: '/a/dns/',
  path: '/a/dns/',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminADevicesIndexRoute = AdminADevicesIndexRouteImport.update({
  id: '/a/devices/',
  path: '/a/devices/',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminADevicegroupsIndexRoute = AdminADevicegroupsIndexRouteImport.update({
  id: '/a/devicegroups/',
  path: '/a/devicegroups/',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminADashboardIndexRoute = AdminADashboardIndexRouteImport.update({
  id: '/a/dashboard/',
  path: '/a/dashboard/',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminAChangelogIndexRoute = AdminAChangelogIndexRouteImport.update({
  id: '/a/changelog/',
  path: '/a/changelog/',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminAAccountsIndexRoute = AdminAAccountsIndexRouteImport.update({
  id: '/a/accounts/',
  path: '/a/accounts/',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminAAccessVisualizationIndexRoute =
  AdminAAccessVisualizationIndexRouteImport.update({
    id: '/a/access-visualization/',
    path: '/a/access-visualization/',
    getParentRoute: () => AdminLazyRoute,
  } as any)
const StaticSLoginServerErrorRoute = StaticSLoginServerErrorRouteImport.update({
  id: '/s/login/server-error',
  path: '/s/login/server-error',
  getParentRoute: () => StaticLazyRoute,
} as any)
const StaticSLoginOutdatedRoute = StaticSLoginOutdatedRouteImport.update({
  id: '/s/login/outdated',
  path: '/s/login/outdated',
  getParentRoute: () => StaticLazyRoute,
} as any)
const StaticSLoginInvalidCsrfRoute = StaticSLoginInvalidCsrfRouteImport.update({
  id: '/s/login/invalid-csrf',
  path: '/s/login/invalid-csrf',
  getParentRoute: () => StaticLazyRoute,
} as any)
const StaticSLoginDisabledRoute = StaticSLoginDisabledRouteImport.update({
  id: '/s/login/disabled',
  path: '/s/login/disabled',
  getParentRoute: () => StaticLazyRoute,
} as any)
const AdminAUsersInviteRoute = AdminAUsersInviteRouteImport.update({
  id: '/a/users/invite',
  path: '/a/users/invite',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminATenantsCreateRoute = AdminATenantsCreateRouteImport.update({
  id: '/a/tenants/create',
  path: '/a/tenants/create',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminASubnetsSubnetsRoute = AdminASubnetsSubnetsRouteImport.update({
  id: '/a/subnets/_subnets',
  path: '/a/subnets',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminASettingsSettingsRoute = AdminASettingsSettingsRouteImport.update({
  id: '/a/settings/_settings',
  path: '/a/settings',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminAGroupsCreateLocalRoute = AdminAGroupsCreateLocalRouteImport.update({
  id: '/a/groups/create-local',
  path: '/a/groups/create-local',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminAGroupsGroupsRoute = AdminAGroupsGroupsRouteImport.update({
  id: '/a/groups/_groups',
  path: '/a/groups',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminAExitnodesExitnodesRoute =
  AdminAExitnodesExitnodesRouteImport.update({
    id: '/a/exitnodes/_exitnodes',
    path: '/a/exitnodes',
    getParentRoute: () => AdminLazyRoute,
  } as any)
const AdminADnsDnsRoute = AdminADnsDnsRouteImport.update({
  id: '/a/dns/_dns',
  path: '/a/dns',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminADevicesCreateServerRoute =
  AdminADevicesCreateServerRouteImport.update({
    id: '/a/devices/create-server',
    path: '/a/devices/create-server',
    getParentRoute: () => AdminLazyRoute,
  } as any)
const AdminAPluginsPluginIdIndexRoute =
  AdminAPluginsPluginIdIndexRouteImport.update({
    id: '/a/plugins/$pluginId/',
    path: '/a/plugins/$pluginId/',
    getParentRoute: () => AdminLazyRoute,
  } as any)
const AdminAUsersUserIdUserRoute = AdminAUsersUserIdUserRouteImport.update({
  id: '/a/users/$userId/_user',
  path: '/a/users/$userId',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminATenantsTenantIdDeletePreviewRoute =
  AdminATenantsTenantIdDeletePreviewRouteImport.update({
    id: '/a/tenants/$tenantId/delete-preview',
    path: '/a/tenants/$tenantId/delete-preview',
    getParentRoute: () => AdminLazyRoute,
  } as any)
const AdminATenantsTenantIdTenantRoute =
  AdminATenantsTenantIdTenantRouteImport.update({
    id: '/a/tenants/$tenantId/_tenant',
    path: '/a/tenants/$tenantId',
    getParentRoute: () => AdminLazyRoute,
  } as any)
const AdminATagsTagIdTagsRoute = AdminATagsTagIdTagsRouteImport.update({
  id: '/a/tags/$tagId/_tags',
  path: '/a/tags/$tagId',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AdminASubnetsSubnetsPendingRoute =
  AdminASubnetsSubnetsPendingRouteImport.update({
    id: '/pending',
    path: '/pending',
    getParentRoute: () => AdminASubnetsSubnetsRoute,
  } as any)
const AdminASubnetsSubnetsApprovedRoute =
  AdminASubnetsSubnetsApprovedRouteImport.update({
    id: '/approved',
    path: '/approved',
    getParentRoute: () => AdminASubnetsSubnetsRoute,
  } as any)
const AdminASubnetsSubnetIdSubnetRoute =
  AdminASubnetsSubnetIdSubnetRouteImport.update({
    id: '/a/subnets/$subnetId/_subnet',
    path: '/a/subnets/$subnetId',
    getParentRoute: () => AdminLazyRoute,
  } as any)
const AdminASettingsSettingsLocalRoute =
  AdminASettingsSettingsLocalRouteImport.update({
    id: '/local',
    path: '/local',
    getParentRoute: () => AdminASettingsSettingsRoute,
  } as any)
const AdminASettingsSettingsGeneralRoute =
  AdminASettingsSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AdminASettingsSettingsRoute,
  } as any)
const AdminASettingsSettingsEphemeralRoute =
  AdminASettingsSettingsEphemeralRouteImport.update({
    id: '/ephemeral',
    path: '/ephemeral',
    getParentRoute: () => AdminASettingsSettingsRoute,
  } as any)
const AdminARulesetsRulesetIdRulesetRoute =
  AdminARulesetsRulesetIdRulesetRouteImport.update({
    id: '/a/rulesets/$rulesetId/_ruleset',
    path: '/a/rulesets/$rulesetId',
    getParentRoute: () => AdminLazyRoute,
  } as any)
const AdminAPluginsPluginIdPluginRoute =
  AdminAPluginsPluginIdPluginRouteImport.update({
    id: '/a/plugins/$pluginId/_plugin',
    path: '/a/plugins/$pluginId',
    getParentRoute: () => AdminLazyRoute,
  } as any)
const AdminAGroupsGroupsScimRoute = AdminAGroupsGroupsScimRouteImport.update({
  id: '/scim',
  path: '/scim',
  getParentRoute: () => AdminAGroupsGroupsRoute,
} as any)
const AdminAGroupsGroupsLocalRoute = AdminAGroupsGroupsLocalRouteImport.update({
  id: '/local',
  path: '/local',
  getParentRoute: () => AdminAGroupsGroupsRoute,
} as any)
const AdminAGroupsGroupsLdapRoute = AdminAGroupsGroupsLdapRouteImport.update({
  id: '/ldap',
  path: '/ldap',
  getParentRoute: () => AdminAGroupsGroupsRoute,
} as any)
const AdminAGroupsGroupIdGroupRoute =
  AdminAGroupsGroupIdGroupRouteImport.update({
    id: '/a/groups/$groupId/_group',
    path: '/a/groups/$groupId',
    getParentRoute: () => AdminLazyRoute,
  } as any)
const AdminAExitnodesExitnodesPendingRoute =
  AdminAExitnodesExitnodesPendingRouteImport.update({
    id: '/pending',
    path: '/pending',
    getParentRoute: () => AdminAExitnodesExitnodesRoute,
  } as any)
const AdminAExitnodesExitnodesApprovedRoute =
  AdminAExitnodesExitnodesApprovedRouteImport.update({
    id: '/approved',
    path: '/approved',
    getParentRoute: () => AdminAExitnodesExitnodesRoute,
  } as any)
const AdminADnsDnsSplitRoute = AdminADnsDnsSplitRouteImport.update({
  id: '/split',
  path: '/split',
  getParentRoute: () => AdminADnsDnsRoute,
} as any)
const AdminADnsDnsSearchDomainsRoute =
  AdminADnsDnsSearchDomainsRouteImport.update({
    id: '/search-domains',
    path: '/search-domains',
    getParentRoute: () => AdminADnsDnsRoute,
  } as any)
const AdminADnsDnsGlobalRoute = AdminADnsDnsGlobalRouteImport.update({
  id: '/global',
  path: '/global',
  getParentRoute: () => AdminADnsDnsRoute,
} as any)
const AdminADevicesDeviceIdDeviceRoute =
  AdminADevicesDeviceIdDeviceRouteImport.update({
    id: '/a/devices/$deviceId/_device',
    path: '/a/devices/$deviceId',
    getParentRoute: () => AdminLazyRoute,
  } as any)
const AdminADevicegroupsDeviceGroupIdDevicegroupsRoute =
  AdminADevicegroupsDeviceGroupIdDevicegroupsRouteImport.update({
    id: '/a/devicegroups/$deviceGroupId/_devicegroups',
    path: '/a/devicegroups/$deviceGroupId',
    getParentRoute: () => AdminLazyRoute,
  } as any)
const AdminASettingsSettingsOidcIndexRoute =
  AdminASettingsSettingsOidcIndexRouteImport.update({
    id: '/oidc/',
    path: '/oidc/',
    getParentRoute: () => AdminASettingsSettingsRoute,
  } as any)
const AdminADnsDnsExtraRecordsIndexRoute =
  AdminADnsDnsExtraRecordsIndexRouteImport.update({
    id: '/extra-records/',
    path: '/extra-records/',
    getParentRoute: () => AdminADnsDnsRoute,
  } as any)
const AdminAUsersUserIdUserInvitationRoute =
  AdminAUsersUserIdUserInvitationRouteImport.update({
    id: '/invitation',
    path: '/invitation',
    getParentRoute: () => AdminAUsersUserIdUserRoute,
  } as any)
const AdminAUsersUserIdUserGeneralRoute =
  AdminAUsersUserIdUserGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AdminAUsersUserIdUserRoute,
  } as any)
const AdminAUsersUserIdUserAccessHistoryRoute =
  AdminAUsersUserIdUserAccessHistoryRouteImport.update({
    id: '/access-history',
    path: '/access-history',
    getParentRoute: () => AdminAUsersUserIdUserRoute,
  } as any)
const AdminATenantsTenantIdTenantSplitDnsRoute =
  AdminATenantsTenantIdTenantSplitDnsRouteImport.update({
    id: '/split-dns',
    path: '/split-dns',
    getParentRoute: () => AdminATenantsTenantIdTenantRoute,
  } as any)
const AdminATenantsTenantIdTenantSearchDomainRoute =
  AdminATenantsTenantIdTenantSearchDomainRouteImport.update({
    id: '/search-domain',
    path: '/search-domain',
    getParentRoute: () => AdminATenantsTenantIdTenantRoute,
  } as any)
const AdminATenantsTenantIdTenantScimRoute =
  AdminATenantsTenantIdTenantScimRouteImport.update({
    id: '/scim',
    path: '/scim',
    getParentRoute: () => AdminATenantsTenantIdTenantRoute,
  } as any)
const AdminATenantsTenantIdTenantOidcRoute =
  AdminATenantsTenantIdTenantOidcRouteImport.update({
    id: '/oidc',
    path: '/oidc',
    getParentRoute: () => AdminATenantsTenantIdTenantRoute,
  } as any)
const AdminATenantsTenantIdTenantLdapRoute =
  AdminATenantsTenantIdTenantLdapRouteImport.update({
    id: '/ldap',
    path: '/ldap',
    getParentRoute: () => AdminATenantsTenantIdTenantRoute,
  } as any)
const AdminATenantsTenantIdTenantGeneralRoute =
  AdminATenantsTenantIdTenantGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AdminATenantsTenantIdTenantRoute,
  } as any)
const AdminATagsTagIdTagsOutboundAclsRoute =
  AdminATagsTagIdTagsOutboundAclsRouteImport.update({
    id: '/outbound-acls',
    path: '/outbound-acls',
    getParentRoute: () => AdminATagsTagIdTagsRoute,
  } as any)
const AdminATagsTagIdTagsInboundAclsRoute =
  AdminATagsTagIdTagsInboundAclsRouteImport.update({
    id: '/inbound-acls',
    path: '/inbound-acls',
    getParentRoute: () => AdminATagsTagIdTagsRoute,
  } as any)
const AdminATagsTagIdTagsAssociatedRoute =
  AdminATagsTagIdTagsAssociatedRouteImport.update({
    id: '/associated',
    path: '/associated',
    getParentRoute: () => AdminATagsTagIdTagsRoute,
  } as any)
const AdminASubnetsSubnetIdSubnetRoutersRoute =
  AdminASubnetsSubnetIdSubnetRoutersRouteImport.update({
    id: '/routers',
    path: '/routers',
    getParentRoute: () => AdminASubnetsSubnetIdSubnetRoute,
  } as any)
const AdminASubnetsSubnetIdSubnetOutboundAclsRoute =
  AdminASubnetsSubnetIdSubnetOutboundAclsRouteImport.update({
    id: '/outbound-acls',
    path: '/outbound-acls',
    getParentRoute: () => AdminASubnetsSubnetIdSubnetRoute,
  } as any)
const AdminASubnetsSubnetIdSubnetInboundAclsRoute =
  AdminASubnetsSubnetIdSubnetInboundAclsRouteImport.update({
    id: '/inbound-acls',
    path: '/inbound-acls',
    getParentRoute: () => AdminASubnetsSubnetIdSubnetRoute,
  } as any)
const AdminARulesetsRulesetIdRulesetRulesRoute =
  AdminARulesetsRulesetIdRulesetRulesRouteImport.update({
    id: '/rules',
    path: '/rules',
    getParentRoute: () => AdminARulesetsRulesetIdRulesetRoute,
  } as any)
const AdminARulesetsRulesetIdRulesetInstancesRoute =
  AdminARulesetsRulesetIdRulesetInstancesRouteImport.update({
    id: '/instances',
    path: '/instances',
    getParentRoute: () => AdminARulesetsRulesetIdRulesetRoute,
  } as any)
const AdminAPluginsPluginIdPluginRulesetsRoute =
  AdminAPluginsPluginIdPluginRulesetsRouteImport.update({
    id: '/rulesets',
    path: '/rulesets',
    getParentRoute: () => AdminAPluginsPluginIdPluginRoute,
  } as any)
const AdminAGroupsGroupIdGroupOutboundAclsRoute =
  AdminAGroupsGroupIdGroupOutboundAclsRouteImport.update({
    id: '/outbound-acls',
    path: '/outbound-acls',
    getParentRoute: () => AdminAGroupsGroupIdGroupRoute,
  } as any)
const AdminAGroupsGroupIdGroupInboundAclsRoute =
  AdminAGroupsGroupIdGroupInboundAclsRouteImport.update({
    id: '/inbound-acls',
    path: '/inbound-acls',
    getParentRoute: () => AdminAGroupsGroupIdGroupRoute,
  } as any)
const AdminAGroupsGroupIdGroupGeneralRoute =
  AdminAGroupsGroupIdGroupGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AdminAGroupsGroupIdGroupRoute,
  } as any)
const AdminADnsDnsExtraRecordsCreateNewDomainRoute =
  AdminADnsDnsExtraRecordsCreateNewDomainRouteImport.update({
    id: '/extra-records/create-new-domain',
    path: '/extra-records/create-new-domain',
    getParentRoute: () => AdminADnsDnsRoute,
  } as any)
const AdminADevicesDeviceIdDeviceOutboundAclsRoute =
  AdminADevicesDeviceIdDeviceOutboundAclsRouteImport.update({
    id: '/outbound-acls',
    path: '/outbound-acls',
    getParentRoute: () => AdminADevicesDeviceIdDeviceRoute,
  } as any)
const AdminADevicesDeviceIdDeviceInboundAclsRoute =
  AdminADevicesDeviceIdDeviceInboundAclsRouteImport.update({
    id: '/inbound-acls',
    path: '/inbound-acls',
    getParentRoute: () => AdminADevicesDeviceIdDeviceRoute,
  } as any)
const AdminADevicesDeviceIdDeviceGeneralRoute =
  AdminADevicesDeviceIdDeviceGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AdminADevicesDeviceIdDeviceRoute,
  } as any)
const AdminADevicesDeviceIdDeviceDebugRoute =
  AdminADevicesDeviceIdDeviceDebugRouteImport.update({
    id: '/debug',
    path: '/debug',
    getParentRoute: () => AdminADevicesDeviceIdDeviceRoute,
  } as any)
const AdminADevicegroupsDeviceGroupIdDevicegroupsOutboundAclsRoute =
  AdminADevicegroupsDeviceGroupIdDevicegroupsOutboundAclsRouteImport.update({
    id: '/outbound-acls',
    path: '/outbound-acls',
    getParentRoute: () => AdminADevicegroupsDeviceGroupIdDevicegroupsRoute,
  } as any)
const AdminADevicegroupsDeviceGroupIdDevicegroupsInboundAclsRoute =
  AdminADevicegroupsDeviceGroupIdDevicegroupsInboundAclsRouteImport.update({
    id: '/inbound-acls',
    path: '/inbound-acls',
    getParentRoute: () => AdminADevicegroupsDeviceGroupIdDevicegroupsRoute,
  } as any)
const AdminADevicegroupsDeviceGroupIdDevicegroupsAssociatedRoute =
  AdminADevicegroupsDeviceGroupIdDevicegroupsAssociatedRouteImport.update({
    id: '/associated',
    path: '/associated',
    getParentRoute: () => AdminADevicegroupsDeviceGroupIdDevicegroupsRoute,
  } as any)
const AdminASettingsSettingsOidcProviderIdIndexRoute =
  AdminASettingsSettingsOidcProviderIdIndexRouteImport.update({
    id: '/oidc/$providerId/',
    path: '/oidc/$providerId/',
    getParentRoute: () => AdminASettingsSettingsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/a/devices/create-server': typeof AdminADevicesCreateServerRoute
  '/a/dns': typeof AdminADnsDnsRouteWithChildren
  '/a/exitnodes': typeof AdminAExitnodesExitnodesRouteWithChildren
  '/a/groups': typeof AdminAGroupsGroupsRouteWithChildren
  '/a/groups/create-local': typeof AdminAGroupsCreateLocalRoute
  '/a/settings': typeof AdminASettingsSettingsRouteWithChildren
  '/a/subnets': typeof AdminASubnetsSubnetsRouteWithChildren
  '/a/tenants/create': typeof AdminATenantsCreateRoute
  '/a/users/invite': typeof AdminAUsersInviteRoute
  '/s/login/disabled': typeof StaticSLoginDisabledRoute
  '/s/login/invalid-csrf': typeof StaticSLoginInvalidCsrfRoute
  '/s/login/outdated': typeof StaticSLoginOutdatedRoute
  '/s/login/server-error': typeof StaticSLoginServerErrorRoute
  '/a/access-visualization/': typeof AdminAAccessVisualizationIndexRoute
  '/a/accounts/': typeof AdminAAccountsIndexRoute
  '/a/changelog/': typeof AdminAChangelogIndexRoute
  '/a/dashboard/': typeof AdminADashboardIndexRoute
  '/a/devicegroups/': typeof AdminADevicegroupsIndexRoute
  '/a/devices/': typeof AdminADevicesIndexRoute
  '/a/dns/': typeof AdminADnsIndexRoute
  '/a/exitnodes/': typeof AdminAExitnodesIndexRoute
  '/a/groups/': typeof AdminAGroupsIndexRoute
  '/a/logs/': typeof AdminALogsIndexRoute
  '/a/plugins/': typeof AdminAPluginsIndexRoute
  '/a/preauthkeys/': typeof AdminAPreauthkeysIndexRoute
  '/a/profile/': typeof AdminAProfileIndexRoute
  '/a/rulesets/': typeof AdminARulesetsIndexRoute
  '/a/settings/': typeof AdminASettingsIndexRoute
  '/a/subnets/': typeof AdminASubnetsIndexRoute
  '/a/tags/': typeof AdminATagsIndexRoute
  '/a/tenants/': typeof AdminATenantsIndexRoute
  '/a/users/': typeof AdminAUsersIndexRoute
  '/a/devicegroups/$deviceGroupId': typeof AdminADevicegroupsDeviceGroupIdDevicegroupsRouteWithChildren
  '/a/devices/$deviceId': typeof AdminADevicesDeviceIdDeviceRouteWithChildren
  '/a/dns/global': typeof AdminADnsDnsGlobalRoute
  '/a/dns/search-domains': typeof AdminADnsDnsSearchDomainsRoute
  '/a/dns/split': typeof AdminADnsDnsSplitRoute
  '/a/exitnodes/approved': typeof AdminAExitnodesExitnodesApprovedRoute
  '/a/exitnodes/pending': typeof AdminAExitnodesExitnodesPendingRoute
  '/a/groups/$groupId': typeof AdminAGroupsGroupIdGroupRouteWithChildren
  '/a/groups/ldap': typeof AdminAGroupsGroupsLdapRoute
  '/a/groups/local': typeof AdminAGroupsGroupsLocalRoute
  '/a/groups/scim': typeof AdminAGroupsGroupsScimRoute
  '/a/plugins/$pluginId': typeof AdminAPluginsPluginIdPluginRouteWithChildren
  '/a/rulesets/$rulesetId': typeof AdminARulesetsRulesetIdRulesetRouteWithChildren
  '/a/settings/ephemeral': typeof AdminASettingsSettingsEphemeralRoute
  '/a/settings/general': typeof AdminASettingsSettingsGeneralRoute
  '/a/settings/local': typeof AdminASettingsSettingsLocalRoute
  '/a/subnets/$subnetId': typeof AdminASubnetsSubnetIdSubnetRouteWithChildren
  '/a/subnets/approved': typeof AdminASubnetsSubnetsApprovedRoute
  '/a/subnets/pending': typeof AdminASubnetsSubnetsPendingRoute
  '/a/tags/$tagId': typeof AdminATagsTagIdTagsRouteWithChildren
  '/a/tenants/$tenantId': typeof AdminATenantsTenantIdTenantRouteWithChildren
  '/a/tenants/$tenantId/delete-preview': typeof AdminATenantsTenantIdDeletePreviewRoute
  '/a/users/$userId': typeof AdminAUsersUserIdUserRouteWithChildren
  '/a/plugins/$pluginId/': typeof AdminAPluginsPluginIdIndexRoute
  '/a/devicegroups/$deviceGroupId/associated': typeof AdminADevicegroupsDeviceGroupIdDevicegroupsAssociatedRoute
  '/a/devicegroups/$deviceGroupId/inbound-acls': typeof AdminADevicegroupsDeviceGroupIdDevicegroupsInboundAclsRoute
  '/a/devicegroups/$deviceGroupId/outbound-acls': typeof AdminADevicegroupsDeviceGroupIdDevicegroupsOutboundAclsRoute
  '/a/devices/$deviceId/debug': typeof AdminADevicesDeviceIdDeviceDebugRoute
  '/a/devices/$deviceId/general': typeof AdminADevicesDeviceIdDeviceGeneralRoute
  '/a/devices/$deviceId/inbound-acls': typeof AdminADevicesDeviceIdDeviceInboundAclsRoute
  '/a/devices/$deviceId/outbound-acls': typeof AdminADevicesDeviceIdDeviceOutboundAclsRoute
  '/a/dns/extra-records/create-new-domain': typeof AdminADnsDnsExtraRecordsCreateNewDomainRoute
  '/a/groups/$groupId/general': typeof AdminAGroupsGroupIdGroupGeneralRoute
  '/a/groups/$groupId/inbound-acls': typeof AdminAGroupsGroupIdGroupInboundAclsRoute
  '/a/groups/$groupId/outbound-acls': typeof AdminAGroupsGroupIdGroupOutboundAclsRoute
  '/a/plugins/$pluginId/rulesets': typeof AdminAPluginsPluginIdPluginRulesetsRoute
  '/a/rulesets/$rulesetId/instances': typeof AdminARulesetsRulesetIdRulesetInstancesRoute
  '/a/rulesets/$rulesetId/rules': typeof AdminARulesetsRulesetIdRulesetRulesRoute
  '/a/subnets/$subnetId/inbound-acls': typeof AdminASubnetsSubnetIdSubnetInboundAclsRoute
  '/a/subnets/$subnetId/outbound-acls': typeof AdminASubnetsSubnetIdSubnetOutboundAclsRoute
  '/a/subnets/$subnetId/routers': typeof AdminASubnetsSubnetIdSubnetRoutersRoute
  '/a/tags/$tagId/associated': typeof AdminATagsTagIdTagsAssociatedRoute
  '/a/tags/$tagId/inbound-acls': typeof AdminATagsTagIdTagsInboundAclsRoute
  '/a/tags/$tagId/outbound-acls': typeof AdminATagsTagIdTagsOutboundAclsRoute
  '/a/tenants/$tenantId/general': typeof AdminATenantsTenantIdTenantGeneralRoute
  '/a/tenants/$tenantId/ldap': typeof AdminATenantsTenantIdTenantLdapRoute
  '/a/tenants/$tenantId/oidc': typeof AdminATenantsTenantIdTenantOidcRoute
  '/a/tenants/$tenantId/scim': typeof AdminATenantsTenantIdTenantScimRoute
  '/a/tenants/$tenantId/search-domain': typeof AdminATenantsTenantIdTenantSearchDomainRoute
  '/a/tenants/$tenantId/split-dns': typeof AdminATenantsTenantIdTenantSplitDnsRoute
  '/a/users/$userId/access-history': typeof AdminAUsersUserIdUserAccessHistoryRoute
  '/a/users/$userId/general': typeof AdminAUsersUserIdUserGeneralRoute
  '/a/users/$userId/invitation': typeof AdminAUsersUserIdUserInvitationRoute
  '/a/dns/extra-records/': typeof AdminADnsDnsExtraRecordsIndexRoute
  '/a/settings/oidc/': typeof AdminASettingsSettingsOidcIndexRoute
  '/a/settings/oidc/$providerId/': typeof AdminASettingsSettingsOidcProviderIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/a/devices/create-server': typeof AdminADevicesCreateServerRoute
  '/a/dns': typeof AdminADnsIndexRoute
  '/a/exitnodes': typeof AdminAExitnodesIndexRoute
  '/a/groups': typeof AdminAGroupsIndexRoute
  '/a/groups/create-local': typeof AdminAGroupsCreateLocalRoute
  '/a/settings': typeof AdminASettingsIndexRoute
  '/a/subnets': typeof AdminASubnetsIndexRoute
  '/a/tenants/create': typeof AdminATenantsCreateRoute
  '/a/users/invite': typeof AdminAUsersInviteRoute
  '/s/login/disabled': typeof StaticSLoginDisabledRoute
  '/s/login/invalid-csrf': typeof StaticSLoginInvalidCsrfRoute
  '/s/login/outdated': typeof StaticSLoginOutdatedRoute
  '/s/login/server-error': typeof StaticSLoginServerErrorRoute
  '/a/access-visualization': typeof AdminAAccessVisualizationIndexRoute
  '/a/accounts': typeof AdminAAccountsIndexRoute
  '/a/changelog': typeof AdminAChangelogIndexRoute
  '/a/dashboard': typeof AdminADashboardIndexRoute
  '/a/devicegroups': typeof AdminADevicegroupsIndexRoute
  '/a/devices': typeof AdminADevicesIndexRoute
  '/a/logs': typeof AdminALogsIndexRoute
  '/a/plugins': typeof AdminAPluginsIndexRoute
  '/a/preauthkeys': typeof AdminAPreauthkeysIndexRoute
  '/a/profile': typeof AdminAProfileIndexRoute
  '/a/rulesets': typeof AdminARulesetsIndexRoute
  '/a/tags': typeof AdminATagsIndexRoute
  '/a/tenants': typeof AdminATenantsIndexRoute
  '/a/users': typeof AdminAUsersIndexRoute
  '/a/devicegroups/$deviceGroupId': typeof AdminADevicegroupsDeviceGroupIdDevicegroupsRouteWithChildren
  '/a/devices/$deviceId': typeof AdminADevicesDeviceIdDeviceRouteWithChildren
  '/a/dns/global': typeof AdminADnsDnsGlobalRoute
  '/a/dns/search-domains': typeof AdminADnsDnsSearchDomainsRoute
  '/a/dns/split': typeof AdminADnsDnsSplitRoute
  '/a/exitnodes/approved': typeof AdminAExitnodesExitnodesApprovedRoute
  '/a/exitnodes/pending': typeof AdminAExitnodesExitnodesPendingRoute
  '/a/groups/$groupId': typeof AdminAGroupsGroupIdGroupRouteWithChildren
  '/a/groups/ldap': typeof AdminAGroupsGroupsLdapRoute
  '/a/groups/local': typeof AdminAGroupsGroupsLocalRoute
  '/a/groups/scim': typeof AdminAGroupsGroupsScimRoute
  '/a/plugins/$pluginId': typeof AdminAPluginsPluginIdIndexRoute
  '/a/rulesets/$rulesetId': typeof AdminARulesetsRulesetIdRulesetRouteWithChildren
  '/a/settings/ephemeral': typeof AdminASettingsSettingsEphemeralRoute
  '/a/settings/general': typeof AdminASettingsSettingsGeneralRoute
  '/a/settings/local': typeof AdminASettingsSettingsLocalRoute
  '/a/subnets/$subnetId': typeof AdminASubnetsSubnetIdSubnetRouteWithChildren
  '/a/subnets/approved': typeof AdminASubnetsSubnetsApprovedRoute
  '/a/subnets/pending': typeof AdminASubnetsSubnetsPendingRoute
  '/a/tags/$tagId': typeof AdminATagsTagIdTagsRouteWithChildren
  '/a/tenants/$tenantId': typeof AdminATenantsTenantIdTenantRouteWithChildren
  '/a/tenants/$tenantId/delete-preview': typeof AdminATenantsTenantIdDeletePreviewRoute
  '/a/users/$userId': typeof AdminAUsersUserIdUserRouteWithChildren
  '/a/devicegroups/$deviceGroupId/associated': typeof AdminADevicegroupsDeviceGroupIdDevicegroupsAssociatedRoute
  '/a/devicegroups/$deviceGroupId/inbound-acls': typeof AdminADevicegroupsDeviceGroupIdDevicegroupsInboundAclsRoute
  '/a/devicegroups/$deviceGroupId/outbound-acls': typeof AdminADevicegroupsDeviceGroupIdDevicegroupsOutboundAclsRoute
  '/a/devices/$deviceId/debug': typeof AdminADevicesDeviceIdDeviceDebugRoute
  '/a/devices/$deviceId/general': typeof AdminADevicesDeviceIdDeviceGeneralRoute
  '/a/devices/$deviceId/inbound-acls': typeof AdminADevicesDeviceIdDeviceInboundAclsRoute
  '/a/devices/$deviceId/outbound-acls': typeof AdminADevicesDeviceIdDeviceOutboundAclsRoute
  '/a/dns/extra-records/create-new-domain': typeof AdminADnsDnsExtraRecordsCreateNewDomainRoute
  '/a/groups/$groupId/general': typeof AdminAGroupsGroupIdGroupGeneralRoute
  '/a/groups/$groupId/inbound-acls': typeof AdminAGroupsGroupIdGroupInboundAclsRoute
  '/a/groups/$groupId/outbound-acls': typeof AdminAGroupsGroupIdGroupOutboundAclsRoute
  '/a/plugins/$pluginId/rulesets': typeof AdminAPluginsPluginIdPluginRulesetsRoute
  '/a/rulesets/$rulesetId/instances': typeof AdminARulesetsRulesetIdRulesetInstancesRoute
  '/a/rulesets/$rulesetId/rules': typeof AdminARulesetsRulesetIdRulesetRulesRoute
  '/a/subnets/$subnetId/inbound-acls': typeof AdminASubnetsSubnetIdSubnetInboundAclsRoute
  '/a/subnets/$subnetId/outbound-acls': typeof AdminASubnetsSubnetIdSubnetOutboundAclsRoute
  '/a/subnets/$subnetId/routers': typeof AdminASubnetsSubnetIdSubnetRoutersRoute
  '/a/tags/$tagId/associated': typeof AdminATagsTagIdTagsAssociatedRoute
  '/a/tags/$tagId/inbound-acls': typeof AdminATagsTagIdTagsInboundAclsRoute
  '/a/tags/$tagId/outbound-acls': typeof AdminATagsTagIdTagsOutboundAclsRoute
  '/a/tenants/$tenantId/general': typeof AdminATenantsTenantIdTenantGeneralRoute
  '/a/tenants/$tenantId/ldap': typeof AdminATenantsTenantIdTenantLdapRoute
  '/a/tenants/$tenantId/oidc': typeof AdminATenantsTenantIdTenantOidcRoute
  '/a/tenants/$tenantId/scim': typeof AdminATenantsTenantIdTenantScimRoute
  '/a/tenants/$tenantId/search-domain': typeof AdminATenantsTenantIdTenantSearchDomainRoute
  '/a/tenants/$tenantId/split-dns': typeof AdminATenantsTenantIdTenantSplitDnsRoute
  '/a/users/$userId/access-history': typeof AdminAUsersUserIdUserAccessHistoryRoute
  '/a/users/$userId/general': typeof AdminAUsersUserIdUserGeneralRoute
  '/a/users/$userId/invitation': typeof AdminAUsersUserIdUserInvitationRoute
  '/a/dns/extra-records': typeof AdminADnsDnsExtraRecordsIndexRoute
  '/a/settings/oidc': typeof AdminASettingsSettingsOidcIndexRoute
  '/a/settings/oidc/$providerId': typeof AdminASettingsSettingsOidcProviderIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_admin': typeof AdminLazyRouteWithChildren
  '/_static': typeof StaticLazyRouteWithChildren
  '/_admin/a/devices/create-server': typeof AdminADevicesCreateServerRoute
  '/_admin/a/dns/_dns': typeof AdminADnsDnsRouteWithChildren
  '/_admin/a/exitnodes/_exitnodes': typeof AdminAExitnodesExitnodesRouteWithChildren
  '/_admin/a/groups/_groups': typeof AdminAGroupsGroupsRouteWithChildren
  '/_admin/a/groups/create-local': typeof AdminAGroupsCreateLocalRoute
  '/_admin/a/settings/_settings': typeof AdminASettingsSettingsRouteWithChildren
  '/_admin/a/subnets/_subnets': typeof AdminASubnetsSubnetsRouteWithChildren
  '/_admin/a/tenants/create': typeof AdminATenantsCreateRoute
  '/_admin/a/users/invite': typeof AdminAUsersInviteRoute
  '/_static/s/login/disabled': typeof StaticSLoginDisabledRoute
  '/_static/s/login/invalid-csrf': typeof StaticSLoginInvalidCsrfRoute
  '/_static/s/login/outdated': typeof StaticSLoginOutdatedRoute
  '/_static/s/login/server-error': typeof StaticSLoginServerErrorRoute
  '/_admin/a/access-visualization/': typeof AdminAAccessVisualizationIndexRoute
  '/_admin/a/accounts/': typeof AdminAAccountsIndexRoute
  '/_admin/a/changelog/': typeof AdminAChangelogIndexRoute
  '/_admin/a/dashboard/': typeof AdminADashboardIndexRoute
  '/_admin/a/devicegroups/': typeof AdminADevicegroupsIndexRoute
  '/_admin/a/devices/': typeof AdminADevicesIndexRoute
  '/_admin/a/dns/': typeof AdminADnsIndexRoute
  '/_admin/a/exitnodes/': typeof AdminAExitnodesIndexRoute
  '/_admin/a/groups/': typeof AdminAGroupsIndexRoute
  '/_admin/a/logs/': typeof AdminALogsIndexRoute
  '/_admin/a/plugins/': typeof AdminAPluginsIndexRoute
  '/_admin/a/preauthkeys/': typeof AdminAPreauthkeysIndexRoute
  '/_admin/a/profile/': typeof AdminAProfileIndexRoute
  '/_admin/a/rulesets/': typeof AdminARulesetsIndexRoute
  '/_admin/a/settings/': typeof AdminASettingsIndexRoute
  '/_admin/a/subnets/': typeof AdminASubnetsIndexRoute
  '/_admin/a/tags/': typeof AdminATagsIndexRoute
  '/_admin/a/tenants/': typeof AdminATenantsIndexRoute
  '/_admin/a/users/': typeof AdminAUsersIndexRoute
  '/_admin/a/devicegroups/$deviceGroupId/_devicegroups': typeof AdminADevicegroupsDeviceGroupIdDevicegroupsRouteWithChildren
  '/_admin/a/devices/$deviceId/_device': typeof AdminADevicesDeviceIdDeviceRouteWithChildren
  '/_admin/a/dns/_dns/global': typeof AdminADnsDnsGlobalRoute
  '/_admin/a/dns/_dns/search-domains': typeof AdminADnsDnsSearchDomainsRoute
  '/_admin/a/dns/_dns/split': typeof AdminADnsDnsSplitRoute
  '/_admin/a/exitnodes/_exitnodes/approved': typeof AdminAExitnodesExitnodesApprovedRoute
  '/_admin/a/exitnodes/_exitnodes/pending': typeof AdminAExitnodesExitnodesPendingRoute
  '/_admin/a/groups/$groupId/_group': typeof AdminAGroupsGroupIdGroupRouteWithChildren
  '/_admin/a/groups/_groups/ldap': typeof AdminAGroupsGroupsLdapRoute
  '/_admin/a/groups/_groups/local': typeof AdminAGroupsGroupsLocalRoute
  '/_admin/a/groups/_groups/scim': typeof AdminAGroupsGroupsScimRoute
  '/_admin/a/plugins/$pluginId/_plugin': typeof AdminAPluginsPluginIdPluginRouteWithChildren
  '/_admin/a/rulesets/$rulesetId/_ruleset': typeof AdminARulesetsRulesetIdRulesetRouteWithChildren
  '/_admin/a/settings/_settings/ephemeral': typeof AdminASettingsSettingsEphemeralRoute
  '/_admin/a/settings/_settings/general': typeof AdminASettingsSettingsGeneralRoute
  '/_admin/a/settings/_settings/local': typeof AdminASettingsSettingsLocalRoute
  '/_admin/a/subnets/$subnetId/_subnet': typeof AdminASubnetsSubnetIdSubnetRouteWithChildren
  '/_admin/a/subnets/_subnets/approved': typeof AdminASubnetsSubnetsApprovedRoute
  '/_admin/a/subnets/_subnets/pending': typeof AdminASubnetsSubnetsPendingRoute
  '/_admin/a/tags/$tagId/_tags': typeof AdminATagsTagIdTagsRouteWithChildren
  '/_admin/a/tenants/$tenantId/_tenant': typeof AdminATenantsTenantIdTenantRouteWithChildren
  '/_admin/a/tenants/$tenantId/delete-preview': typeof AdminATenantsTenantIdDeletePreviewRoute
  '/_admin/a/users/$userId/_user': typeof AdminAUsersUserIdUserRouteWithChildren
  '/_admin/a/plugins/$pluginId/': typeof AdminAPluginsPluginIdIndexRoute
  '/_admin/a/devicegroups/$deviceGroupId/_devicegroups/associated': typeof AdminADevicegroupsDeviceGroupIdDevicegroupsAssociatedRoute
  '/_admin/a/devicegroups/$deviceGroupId/_devicegroups/inbound-acls': typeof AdminADevicegroupsDeviceGroupIdDevicegroupsInboundAclsRoute
  '/_admin/a/devicegroups/$deviceGroupId/_devicegroups/outbound-acls': typeof AdminADevicegroupsDeviceGroupIdDevicegroupsOutboundAclsRoute
  '/_admin/a/devices/$deviceId/_device/debug': typeof AdminADevicesDeviceIdDeviceDebugRoute
  '/_admin/a/devices/$deviceId/_device/general': typeof AdminADevicesDeviceIdDeviceGeneralRoute
  '/_admin/a/devices/$deviceId/_device/inbound-acls': typeof AdminADevicesDeviceIdDeviceInboundAclsRoute
  '/_admin/a/devices/$deviceId/_device/outbound-acls': typeof AdminADevicesDeviceIdDeviceOutboundAclsRoute
  '/_admin/a/dns/_dns/extra-records/create-new-domain': typeof AdminADnsDnsExtraRecordsCreateNewDomainRoute
  '/_admin/a/groups/$groupId/_group/general': typeof AdminAGroupsGroupIdGroupGeneralRoute
  '/_admin/a/groups/$groupId/_group/inbound-acls': typeof AdminAGroupsGroupIdGroupInboundAclsRoute
  '/_admin/a/groups/$groupId/_group/outbound-acls': typeof AdminAGroupsGroupIdGroupOutboundAclsRoute
  '/_admin/a/plugins/$pluginId/_plugin/rulesets': typeof AdminAPluginsPluginIdPluginRulesetsRoute
  '/_admin/a/rulesets/$rulesetId/_ruleset/instances': typeof AdminARulesetsRulesetIdRulesetInstancesRoute
  '/_admin/a/rulesets/$rulesetId/_ruleset/rules': typeof AdminARulesetsRulesetIdRulesetRulesRoute
  '/_admin/a/subnets/$subnetId/_subnet/inbound-acls': typeof AdminASubnetsSubnetIdSubnetInboundAclsRoute
  '/_admin/a/subnets/$subnetId/_subnet/outbound-acls': typeof AdminASubnetsSubnetIdSubnetOutboundAclsRoute
  '/_admin/a/subnets/$subnetId/_subnet/routers': typeof AdminASubnetsSubnetIdSubnetRoutersRoute
  '/_admin/a/tags/$tagId/_tags/associated': typeof AdminATagsTagIdTagsAssociatedRoute
  '/_admin/a/tags/$tagId/_tags/inbound-acls': typeof AdminATagsTagIdTagsInboundAclsRoute
  '/_admin/a/tags/$tagId/_tags/outbound-acls': typeof AdminATagsTagIdTagsOutboundAclsRoute
  '/_admin/a/tenants/$tenantId/_tenant/general': typeof AdminATenantsTenantIdTenantGeneralRoute
  '/_admin/a/tenants/$tenantId/_tenant/ldap': typeof AdminATenantsTenantIdTenantLdapRoute
  '/_admin/a/tenants/$tenantId/_tenant/oidc': typeof AdminATenantsTenantIdTenantOidcRoute
  '/_admin/a/tenants/$tenantId/_tenant/scim': typeof AdminATenantsTenantIdTenantScimRoute
  '/_admin/a/tenants/$tenantId/_tenant/search-domain': typeof AdminATenantsTenantIdTenantSearchDomainRoute
  '/_admin/a/tenants/$tenantId/_tenant/split-dns': typeof AdminATenantsTenantIdTenantSplitDnsRoute
  '/_admin/a/users/$userId/_user/access-history': typeof AdminAUsersUserIdUserAccessHistoryRoute
  '/_admin/a/users/$userId/_user/general': typeof AdminAUsersUserIdUserGeneralRoute
  '/_admin/a/users/$userId/_user/invitation': typeof AdminAUsersUserIdUserInvitationRoute
  '/_admin/a/dns/_dns/extra-records/': typeof AdminADnsDnsExtraRecordsIndexRoute
  '/_admin/a/settings/_settings/oidc/': typeof AdminASettingsSettingsOidcIndexRoute
  '/_admin/a/settings/_settings/oidc/$providerId/': typeof AdminASettingsSettingsOidcProviderIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/a/devices/create-server'
    | '/a/dns'
    | '/a/exitnodes'
    | '/a/groups'
    | '/a/groups/create-local'
    | '/a/settings'
    | '/a/subnets'
    | '/a/tenants/create'
    | '/a/users/invite'
    | '/s/login/disabled'
    | '/s/login/invalid-csrf'
    | '/s/login/outdated'
    | '/s/login/server-error'
    | '/a/access-visualization/'
    | '/a/accounts/'
    | '/a/changelog/'
    | '/a/dashboard/'
    | '/a/devicegroups/'
    | '/a/devices/'
    | '/a/dns/'
    | '/a/exitnodes/'
    | '/a/groups/'
    | '/a/logs/'
    | '/a/plugins/'
    | '/a/preauthkeys/'
    | '/a/profile/'
    | '/a/rulesets/'
    | '/a/settings/'
    | '/a/subnets/'
    | '/a/tags/'
    | '/a/tenants/'
    | '/a/users/'
    | '/a/devicegroups/$deviceGroupId'
    | '/a/devices/$deviceId'
    | '/a/dns/global'
    | '/a/dns/search-domains'
    | '/a/dns/split'
    | '/a/exitnodes/approved'
    | '/a/exitnodes/pending'
    | '/a/groups/$groupId'
    | '/a/groups/ldap'
    | '/a/groups/local'
    | '/a/groups/scim'
    | '/a/plugins/$pluginId'
    | '/a/rulesets/$rulesetId'
    | '/a/settings/ephemeral'
    | '/a/settings/general'
    | '/a/settings/local'
    | '/a/subnets/$subnetId'
    | '/a/subnets/approved'
    | '/a/subnets/pending'
    | '/a/tags/$tagId'
    | '/a/tenants/$tenantId'
    | '/a/tenants/$tenantId/delete-preview'
    | '/a/users/$userId'
    | '/a/plugins/$pluginId/'
    | '/a/devicegroups/$deviceGroupId/associated'
    | '/a/devicegroups/$deviceGroupId/inbound-acls'
    | '/a/devicegroups/$deviceGroupId/outbound-acls'
    | '/a/devices/$deviceId/debug'
    | '/a/devices/$deviceId/general'
    | '/a/devices/$deviceId/inbound-acls'
    | '/a/devices/$deviceId/outbound-acls'
    | '/a/dns/extra-records/create-new-domain'
    | '/a/groups/$groupId/general'
    | '/a/groups/$groupId/inbound-acls'
    | '/a/groups/$groupId/outbound-acls'
    | '/a/plugins/$pluginId/rulesets'
    | '/a/rulesets/$rulesetId/instances'
    | '/a/rulesets/$rulesetId/rules'
    | '/a/subnets/$subnetId/inbound-acls'
    | '/a/subnets/$subnetId/outbound-acls'
    | '/a/subnets/$subnetId/routers'
    | '/a/tags/$tagId/associated'
    | '/a/tags/$tagId/inbound-acls'
    | '/a/tags/$tagId/outbound-acls'
    | '/a/tenants/$tenantId/general'
    | '/a/tenants/$tenantId/ldap'
    | '/a/tenants/$tenantId/oidc'
    | '/a/tenants/$tenantId/scim'
    | '/a/tenants/$tenantId/search-domain'
    | '/a/tenants/$tenantId/split-dns'
    | '/a/users/$userId/access-history'
    | '/a/users/$userId/general'
    | '/a/users/$userId/invitation'
    | '/a/dns/extra-records/'
    | '/a/settings/oidc/'
    | '/a/settings/oidc/$providerId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/a/devices/create-server'
    | '/a/dns'
    | '/a/exitnodes'
    | '/a/groups'
    | '/a/groups/create-local'
    | '/a/settings'
    | '/a/subnets'
    | '/a/tenants/create'
    | '/a/users/invite'
    | '/s/login/disabled'
    | '/s/login/invalid-csrf'
    | '/s/login/outdated'
    | '/s/login/server-error'
    | '/a/access-visualization'
    | '/a/accounts'
    | '/a/changelog'
    | '/a/dashboard'
    | '/a/devicegroups'
    | '/a/devices'
    | '/a/logs'
    | '/a/plugins'
    | '/a/preauthkeys'
    | '/a/profile'
    | '/a/rulesets'
    | '/a/tags'
    | '/a/tenants'
    | '/a/users'
    | '/a/devicegroups/$deviceGroupId'
    | '/a/devices/$deviceId'
    | '/a/dns/global'
    | '/a/dns/search-domains'
    | '/a/dns/split'
    | '/a/exitnodes/approved'
    | '/a/exitnodes/pending'
    | '/a/groups/$groupId'
    | '/a/groups/ldap'
    | '/a/groups/local'
    | '/a/groups/scim'
    | '/a/plugins/$pluginId'
    | '/a/rulesets/$rulesetId'
    | '/a/settings/ephemeral'
    | '/a/settings/general'
    | '/a/settings/local'
    | '/a/subnets/$subnetId'
    | '/a/subnets/approved'
    | '/a/subnets/pending'
    | '/a/tags/$tagId'
    | '/a/tenants/$tenantId'
    | '/a/tenants/$tenantId/delete-preview'
    | '/a/users/$userId'
    | '/a/devicegroups/$deviceGroupId/associated'
    | '/a/devicegroups/$deviceGroupId/inbound-acls'
    | '/a/devicegroups/$deviceGroupId/outbound-acls'
    | '/a/devices/$deviceId/debug'
    | '/a/devices/$deviceId/general'
    | '/a/devices/$deviceId/inbound-acls'
    | '/a/devices/$deviceId/outbound-acls'
    | '/a/dns/extra-records/create-new-domain'
    | '/a/groups/$groupId/general'
    | '/a/groups/$groupId/inbound-acls'
    | '/a/groups/$groupId/outbound-acls'
    | '/a/plugins/$pluginId/rulesets'
    | '/a/rulesets/$rulesetId/instances'
    | '/a/rulesets/$rulesetId/rules'
    | '/a/subnets/$subnetId/inbound-acls'
    | '/a/subnets/$subnetId/outbound-acls'
    | '/a/subnets/$subnetId/routers'
    | '/a/tags/$tagId/associated'
    | '/a/tags/$tagId/inbound-acls'
    | '/a/tags/$tagId/outbound-acls'
    | '/a/tenants/$tenantId/general'
    | '/a/tenants/$tenantId/ldap'
    | '/a/tenants/$tenantId/oidc'
    | '/a/tenants/$tenantId/scim'
    | '/a/tenants/$tenantId/search-domain'
    | '/a/tenants/$tenantId/split-dns'
    | '/a/users/$userId/access-history'
    | '/a/users/$userId/general'
    | '/a/users/$userId/invitation'
    | '/a/dns/extra-records'
    | '/a/settings/oidc'
    | '/a/settings/oidc/$providerId'
  id:
    | '__root__'
    | '/'
    | '/_admin'
    | '/_static'
    | '/_admin/a/devices/create-server'
    | '/_admin/a/dns/_dns'
    | '/_admin/a/exitnodes/_exitnodes'
    | '/_admin/a/groups/_groups'
    | '/_admin/a/groups/create-local'
    | '/_admin/a/settings/_settings'
    | '/_admin/a/subnets/_subnets'
    | '/_admin/a/tenants/create'
    | '/_admin/a/users/invite'
    | '/_static/s/login/disabled'
    | '/_static/s/login/invalid-csrf'
    | '/_static/s/login/outdated'
    | '/_static/s/login/server-error'
    | '/_admin/a/access-visualization/'
    | '/_admin/a/accounts/'
    | '/_admin/a/changelog/'
    | '/_admin/a/dashboard/'
    | '/_admin/a/devicegroups/'
    | '/_admin/a/devices/'
    | '/_admin/a/dns/'
    | '/_admin/a/exitnodes/'
    | '/_admin/a/groups/'
    | '/_admin/a/logs/'
    | '/_admin/a/plugins/'
    | '/_admin/a/preauthkeys/'
    | '/_admin/a/profile/'
    | '/_admin/a/rulesets/'
    | '/_admin/a/settings/'
    | '/_admin/a/subnets/'
    | '/_admin/a/tags/'
    | '/_admin/a/tenants/'
    | '/_admin/a/users/'
    | '/_admin/a/devicegroups/$deviceGroupId/_devicegroups'
    | '/_admin/a/devices/$deviceId/_device'
    | '/_admin/a/dns/_dns/global'
    | '/_admin/a/dns/_dns/search-domains'
    | '/_admin/a/dns/_dns/split'
    | '/_admin/a/exitnodes/_exitnodes/approved'
    | '/_admin/a/exitnodes/_exitnodes/pending'
    | '/_admin/a/groups/$groupId/_group'
    | '/_admin/a/groups/_groups/ldap'
    | '/_admin/a/groups/_groups/local'
    | '/_admin/a/groups/_groups/scim'
    | '/_admin/a/plugins/$pluginId/_plugin'
    | '/_admin/a/rulesets/$rulesetId/_ruleset'
    | '/_admin/a/settings/_settings/ephemeral'
    | '/_admin/a/settings/_settings/general'
    | '/_admin/a/settings/_settings/local'
    | '/_admin/a/subnets/$subnetId/_subnet'
    | '/_admin/a/subnets/_subnets/approved'
    | '/_admin/a/subnets/_subnets/pending'
    | '/_admin/a/tags/$tagId/_tags'
    | '/_admin/a/tenants/$tenantId/_tenant'
    | '/_admin/a/tenants/$tenantId/delete-preview'
    | '/_admin/a/users/$userId/_user'
    | '/_admin/a/plugins/$pluginId/'
    | '/_admin/a/devicegroups/$deviceGroupId/_devicegroups/associated'
    | '/_admin/a/devicegroups/$deviceGroupId/_devicegroups/inbound-acls'
    | '/_admin/a/devicegroups/$deviceGroupId/_devicegroups/outbound-acls'
    | '/_admin/a/devices/$deviceId/_device/debug'
    | '/_admin/a/devices/$deviceId/_device/general'
    | '/_admin/a/devices/$deviceId/_device/inbound-acls'
    | '/_admin/a/devices/$deviceId/_device/outbound-acls'
    | '/_admin/a/dns/_dns/extra-records/create-new-domain'
    | '/_admin/a/groups/$groupId/_group/general'
    | '/_admin/a/groups/$groupId/_group/inbound-acls'
    | '/_admin/a/groups/$groupId/_group/outbound-acls'
    | '/_admin/a/plugins/$pluginId/_plugin/rulesets'
    | '/_admin/a/rulesets/$rulesetId/_ruleset/instances'
    | '/_admin/a/rulesets/$rulesetId/_ruleset/rules'
    | '/_admin/a/subnets/$subnetId/_subnet/inbound-acls'
    | '/_admin/a/subnets/$subnetId/_subnet/outbound-acls'
    | '/_admin/a/subnets/$subnetId/_subnet/routers'
    | '/_admin/a/tags/$tagId/_tags/associated'
    | '/_admin/a/tags/$tagId/_tags/inbound-acls'
    | '/_admin/a/tags/$tagId/_tags/outbound-acls'
    | '/_admin/a/tenants/$tenantId/_tenant/general'
    | '/_admin/a/tenants/$tenantId/_tenant/ldap'
    | '/_admin/a/tenants/$tenantId/_tenant/oidc'
    | '/_admin/a/tenants/$tenantId/_tenant/scim'
    | '/_admin/a/tenants/$tenantId/_tenant/search-domain'
    | '/_admin/a/tenants/$tenantId/_tenant/split-dns'
    | '/_admin/a/users/$userId/_user/access-history'
    | '/_admin/a/users/$userId/_user/general'
    | '/_admin/a/users/$userId/_user/invitation'
    | '/_admin/a/dns/_dns/extra-records/'
    | '/_admin/a/settings/_settings/oidc/'
    | '/_admin/a/settings/_settings/oidc/$providerId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminLazyRoute: typeof AdminLazyRouteWithChildren
  StaticLazyRoute: typeof StaticLazyRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_static': {
      id: '/_static'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof StaticLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin': {
      id: '/_admin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AdminLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin/a/users/': {
      id: '/_admin/a/users/'
      path: '/a/users'
      fullPath: '/a/users/'
      preLoaderRoute: typeof AdminAUsersIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/tenants/': {
      id: '/_admin/a/tenants/'
      path: '/a/tenants'
      fullPath: '/a/tenants/'
      preLoaderRoute: typeof AdminATenantsIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/tags/': {
      id: '/_admin/a/tags/'
      path: '/a/tags'
      fullPath: '/a/tags/'
      preLoaderRoute: typeof AdminATagsIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/subnets/': {
      id: '/_admin/a/subnets/'
      path: '/a/subnets'
      fullPath: '/a/subnets/'
      preLoaderRoute: typeof AdminASubnetsIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/settings/': {
      id: '/_admin/a/settings/'
      path: '/a/settings'
      fullPath: '/a/settings/'
      preLoaderRoute: typeof AdminASettingsIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/rulesets/': {
      id: '/_admin/a/rulesets/'
      path: '/a/rulesets'
      fullPath: '/a/rulesets/'
      preLoaderRoute: typeof AdminARulesetsIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/profile/': {
      id: '/_admin/a/profile/'
      path: '/a/profile'
      fullPath: '/a/profile/'
      preLoaderRoute: typeof AdminAProfileIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/preauthkeys/': {
      id: '/_admin/a/preauthkeys/'
      path: '/a/preauthkeys'
      fullPath: '/a/preauthkeys/'
      preLoaderRoute: typeof AdminAPreauthkeysIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/plugins/': {
      id: '/_admin/a/plugins/'
      path: '/a/plugins'
      fullPath: '/a/plugins/'
      preLoaderRoute: typeof AdminAPluginsIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/logs/': {
      id: '/_admin/a/logs/'
      path: '/a/logs'
      fullPath: '/a/logs/'
      preLoaderRoute: typeof AdminALogsIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/groups/': {
      id: '/_admin/a/groups/'
      path: '/a/groups'
      fullPath: '/a/groups/'
      preLoaderRoute: typeof AdminAGroupsIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/exitnodes/': {
      id: '/_admin/a/exitnodes/'
      path: '/a/exitnodes'
      fullPath: '/a/exitnodes/'
      preLoaderRoute: typeof AdminAExitnodesIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/dns/': {
      id: '/_admin/a/dns/'
      path: '/a/dns'
      fullPath: '/a/dns/'
      preLoaderRoute: typeof AdminADnsIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/devices/': {
      id: '/_admin/a/devices/'
      path: '/a/devices'
      fullPath: '/a/devices/'
      preLoaderRoute: typeof AdminADevicesIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/devicegroups/': {
      id: '/_admin/a/devicegroups/'
      path: '/a/devicegroups'
      fullPath: '/a/devicegroups/'
      preLoaderRoute: typeof AdminADevicegroupsIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/dashboard/': {
      id: '/_admin/a/dashboard/'
      path: '/a/dashboard'
      fullPath: '/a/dashboard/'
      preLoaderRoute: typeof AdminADashboardIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/changelog/': {
      id: '/_admin/a/changelog/'
      path: '/a/changelog'
      fullPath: '/a/changelog/'
      preLoaderRoute: typeof AdminAChangelogIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/accounts/': {
      id: '/_admin/a/accounts/'
      path: '/a/accounts'
      fullPath: '/a/accounts/'
      preLoaderRoute: typeof AdminAAccountsIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/access-visualization/': {
      id: '/_admin/a/access-visualization/'
      path: '/a/access-visualization'
      fullPath: '/a/access-visualization/'
      preLoaderRoute: typeof AdminAAccessVisualizationIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_static/s/login/server-error': {
      id: '/_static/s/login/server-error'
      path: '/s/login/server-error'
      fullPath: '/s/login/server-error'
      preLoaderRoute: typeof StaticSLoginServerErrorRouteImport
      parentRoute: typeof StaticLazyRoute
    }
    '/_static/s/login/outdated': {
      id: '/_static/s/login/outdated'
      path: '/s/login/outdated'
      fullPath: '/s/login/outdated'
      preLoaderRoute: typeof StaticSLoginOutdatedRouteImport
      parentRoute: typeof StaticLazyRoute
    }
    '/_static/s/login/invalid-csrf': {
      id: '/_static/s/login/invalid-csrf'
      path: '/s/login/invalid-csrf'
      fullPath: '/s/login/invalid-csrf'
      preLoaderRoute: typeof StaticSLoginInvalidCsrfRouteImport
      parentRoute: typeof StaticLazyRoute
    }
    '/_static/s/login/disabled': {
      id: '/_static/s/login/disabled'
      path: '/s/login/disabled'
      fullPath: '/s/login/disabled'
      preLoaderRoute: typeof StaticSLoginDisabledRouteImport
      parentRoute: typeof StaticLazyRoute
    }
    '/_admin/a/users/invite': {
      id: '/_admin/a/users/invite'
      path: '/a/users/invite'
      fullPath: '/a/users/invite'
      preLoaderRoute: typeof AdminAUsersInviteRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/tenants/create': {
      id: '/_admin/a/tenants/create'
      path: '/a/tenants/create'
      fullPath: '/a/tenants/create'
      preLoaderRoute: typeof AdminATenantsCreateRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/subnets/_subnets': {
      id: '/_admin/a/subnets/_subnets'
      path: '/a/subnets'
      fullPath: '/a/subnets'
      preLoaderRoute: typeof AdminASubnetsSubnetsRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/settings/_settings': {
      id: '/_admin/a/settings/_settings'
      path: '/a/settings'
      fullPath: '/a/settings'
      preLoaderRoute: typeof AdminASettingsSettingsRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/groups/create-local': {
      id: '/_admin/a/groups/create-local'
      path: '/a/groups/create-local'
      fullPath: '/a/groups/create-local'
      preLoaderRoute: typeof AdminAGroupsCreateLocalRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/groups/_groups': {
      id: '/_admin/a/groups/_groups'
      path: '/a/groups'
      fullPath: '/a/groups'
      preLoaderRoute: typeof AdminAGroupsGroupsRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/exitnodes/_exitnodes': {
      id: '/_admin/a/exitnodes/_exitnodes'
      path: '/a/exitnodes'
      fullPath: '/a/exitnodes'
      preLoaderRoute: typeof AdminAExitnodesExitnodesRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/dns/_dns': {
      id: '/_admin/a/dns/_dns'
      path: '/a/dns'
      fullPath: '/a/dns'
      preLoaderRoute: typeof AdminADnsDnsRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/devices/create-server': {
      id: '/_admin/a/devices/create-server'
      path: '/a/devices/create-server'
      fullPath: '/a/devices/create-server'
      preLoaderRoute: typeof AdminADevicesCreateServerRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/plugins/$pluginId/': {
      id: '/_admin/a/plugins/$pluginId/'
      path: '/a/plugins/$pluginId'
      fullPath: '/a/plugins/$pluginId/'
      preLoaderRoute: typeof AdminAPluginsPluginIdIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/users/$userId/_user': {
      id: '/_admin/a/users/$userId/_user'
      path: '/a/users/$userId'
      fullPath: '/a/users/$userId'
      preLoaderRoute: typeof AdminAUsersUserIdUserRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/tenants/$tenantId/delete-preview': {
      id: '/_admin/a/tenants/$tenantId/delete-preview'
      path: '/a/tenants/$tenantId/delete-preview'
      fullPath: '/a/tenants/$tenantId/delete-preview'
      preLoaderRoute: typeof AdminATenantsTenantIdDeletePreviewRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/tenants/$tenantId/_tenant': {
      id: '/_admin/a/tenants/$tenantId/_tenant'
      path: '/a/tenants/$tenantId'
      fullPath: '/a/tenants/$tenantId'
      preLoaderRoute: typeof AdminATenantsTenantIdTenantRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/tags/$tagId/_tags': {
      id: '/_admin/a/tags/$tagId/_tags'
      path: '/a/tags/$tagId'
      fullPath: '/a/tags/$tagId'
      preLoaderRoute: typeof AdminATagsTagIdTagsRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/subnets/_subnets/pending': {
      id: '/_admin/a/subnets/_subnets/pending'
      path: '/pending'
      fullPath: '/a/subnets/pending'
      preLoaderRoute: typeof AdminASubnetsSubnetsPendingRouteImport
      parentRoute: typeof AdminASubnetsSubnetsRoute
    }
    '/_admin/a/subnets/_subnets/approved': {
      id: '/_admin/a/subnets/_subnets/approved'
      path: '/approved'
      fullPath: '/a/subnets/approved'
      preLoaderRoute: typeof AdminASubnetsSubnetsApprovedRouteImport
      parentRoute: typeof AdminASubnetsSubnetsRoute
    }
    '/_admin/a/subnets/$subnetId/_subnet': {
      id: '/_admin/a/subnets/$subnetId/_subnet'
      path: '/a/subnets/$subnetId'
      fullPath: '/a/subnets/$subnetId'
      preLoaderRoute: typeof AdminASubnetsSubnetIdSubnetRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/settings/_settings/local': {
      id: '/_admin/a/settings/_settings/local'
      path: '/local'
      fullPath: '/a/settings/local'
      preLoaderRoute: typeof AdminASettingsSettingsLocalRouteImport
      parentRoute: typeof AdminASettingsSettingsRoute
    }
    '/_admin/a/settings/_settings/general': {
      id: '/_admin/a/settings/_settings/general'
      path: '/general'
      fullPath: '/a/settings/general'
      preLoaderRoute: typeof AdminASettingsSettingsGeneralRouteImport
      parentRoute: typeof AdminASettingsSettingsRoute
    }
    '/_admin/a/settings/_settings/ephemeral': {
      id: '/_admin/a/settings/_settings/ephemeral'
      path: '/ephemeral'
      fullPath: '/a/settings/ephemeral'
      preLoaderRoute: typeof AdminASettingsSettingsEphemeralRouteImport
      parentRoute: typeof AdminASettingsSettingsRoute
    }
    '/_admin/a/rulesets/$rulesetId/_ruleset': {
      id: '/_admin/a/rulesets/$rulesetId/_ruleset'
      path: '/a/rulesets/$rulesetId'
      fullPath: '/a/rulesets/$rulesetId'
      preLoaderRoute: typeof AdminARulesetsRulesetIdRulesetRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/plugins/$pluginId/_plugin': {
      id: '/_admin/a/plugins/$pluginId/_plugin'
      path: '/a/plugins/$pluginId'
      fullPath: '/a/plugins/$pluginId'
      preLoaderRoute: typeof AdminAPluginsPluginIdPluginRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/groups/_groups/scim': {
      id: '/_admin/a/groups/_groups/scim'
      path: '/scim'
      fullPath: '/a/groups/scim'
      preLoaderRoute: typeof AdminAGroupsGroupsScimRouteImport
      parentRoute: typeof AdminAGroupsGroupsRoute
    }
    '/_admin/a/groups/_groups/local': {
      id: '/_admin/a/groups/_groups/local'
      path: '/local'
      fullPath: '/a/groups/local'
      preLoaderRoute: typeof AdminAGroupsGroupsLocalRouteImport
      parentRoute: typeof AdminAGroupsGroupsRoute
    }
    '/_admin/a/groups/_groups/ldap': {
      id: '/_admin/a/groups/_groups/ldap'
      path: '/ldap'
      fullPath: '/a/groups/ldap'
      preLoaderRoute: typeof AdminAGroupsGroupsLdapRouteImport
      parentRoute: typeof AdminAGroupsGroupsRoute
    }
    '/_admin/a/groups/$groupId/_group': {
      id: '/_admin/a/groups/$groupId/_group'
      path: '/a/groups/$groupId'
      fullPath: '/a/groups/$groupId'
      preLoaderRoute: typeof AdminAGroupsGroupIdGroupRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/exitnodes/_exitnodes/pending': {
      id: '/_admin/a/exitnodes/_exitnodes/pending'
      path: '/pending'
      fullPath: '/a/exitnodes/pending'
      preLoaderRoute: typeof AdminAExitnodesExitnodesPendingRouteImport
      parentRoute: typeof AdminAExitnodesExitnodesRoute
    }
    '/_admin/a/exitnodes/_exitnodes/approved': {
      id: '/_admin/a/exitnodes/_exitnodes/approved'
      path: '/approved'
      fullPath: '/a/exitnodes/approved'
      preLoaderRoute: typeof AdminAExitnodesExitnodesApprovedRouteImport
      parentRoute: typeof AdminAExitnodesExitnodesRoute
    }
    '/_admin/a/dns/_dns/split': {
      id: '/_admin/a/dns/_dns/split'
      path: '/split'
      fullPath: '/a/dns/split'
      preLoaderRoute: typeof AdminADnsDnsSplitRouteImport
      parentRoute: typeof AdminADnsDnsRoute
    }
    '/_admin/a/dns/_dns/search-domains': {
      id: '/_admin/a/dns/_dns/search-domains'
      path: '/search-domains'
      fullPath: '/a/dns/search-domains'
      preLoaderRoute: typeof AdminADnsDnsSearchDomainsRouteImport
      parentRoute: typeof AdminADnsDnsRoute
    }
    '/_admin/a/dns/_dns/global': {
      id: '/_admin/a/dns/_dns/global'
      path: '/global'
      fullPath: '/a/dns/global'
      preLoaderRoute: typeof AdminADnsDnsGlobalRouteImport
      parentRoute: typeof AdminADnsDnsRoute
    }
    '/_admin/a/devices/$deviceId/_device': {
      id: '/_admin/a/devices/$deviceId/_device'
      path: '/a/devices/$deviceId'
      fullPath: '/a/devices/$deviceId'
      preLoaderRoute: typeof AdminADevicesDeviceIdDeviceRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/devicegroups/$deviceGroupId/_devicegroups': {
      id: '/_admin/a/devicegroups/$deviceGroupId/_devicegroups'
      path: '/a/devicegroups/$deviceGroupId'
      fullPath: '/a/devicegroups/$deviceGroupId'
      preLoaderRoute: typeof AdminADevicegroupsDeviceGroupIdDevicegroupsRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/_admin/a/settings/_settings/oidc/': {
      id: '/_admin/a/settings/_settings/oidc/'
      path: '/oidc'
      fullPath: '/a/settings/oidc/'
      preLoaderRoute: typeof AdminASettingsSettingsOidcIndexRouteImport
      parentRoute: typeof AdminASettingsSettingsRoute
    }
    '/_admin/a/dns/_dns/extra-records/': {
      id: '/_admin/a/dns/_dns/extra-records/'
      path: '/extra-records'
      fullPath: '/a/dns/extra-records/'
      preLoaderRoute: typeof AdminADnsDnsExtraRecordsIndexRouteImport
      parentRoute: typeof AdminADnsDnsRoute
    }
    '/_admin/a/users/$userId/_user/invitation': {
      id: '/_admin/a/users/$userId/_user/invitation'
      path: '/invitation'
      fullPath: '/a/users/$userId/invitation'
      preLoaderRoute: typeof AdminAUsersUserIdUserInvitationRouteImport
      parentRoute: typeof AdminAUsersUserIdUserRoute
    }
    '/_admin/a/users/$userId/_user/general': {
      id: '/_admin/a/users/$userId/_user/general'
      path: '/general'
      fullPath: '/a/users/$userId/general'
      preLoaderRoute: typeof AdminAUsersUserIdUserGeneralRouteImport
      parentRoute: typeof AdminAUsersUserIdUserRoute
    }
    '/_admin/a/users/$userId/_user/access-history': {
      id: '/_admin/a/users/$userId/_user/access-history'
      path: '/access-history'
      fullPath: '/a/users/$userId/access-history'
      preLoaderRoute: typeof AdminAUsersUserIdUserAccessHistoryRouteImport
      parentRoute: typeof AdminAUsersUserIdUserRoute
    }
    '/_admin/a/tenants/$tenantId/_tenant/split-dns': {
      id: '/_admin/a/tenants/$tenantId/_tenant/split-dns'
      path: '/split-dns'
      fullPath: '/a/tenants/$tenantId/split-dns'
      preLoaderRoute: typeof AdminATenantsTenantIdTenantSplitDnsRouteImport
      parentRoute: typeof AdminATenantsTenantIdTenantRoute
    }
    '/_admin/a/tenants/$tenantId/_tenant/search-domain': {
      id: '/_admin/a/tenants/$tenantId/_tenant/search-domain'
      path: '/search-domain'
      fullPath: '/a/tenants/$tenantId/search-domain'
      preLoaderRoute: typeof AdminATenantsTenantIdTenantSearchDomainRouteImport
      parentRoute: typeof AdminATenantsTenantIdTenantRoute
    }
    '/_admin/a/tenants/$tenantId/_tenant/scim': {
      id: '/_admin/a/tenants/$tenantId/_tenant/scim'
      path: '/scim'
      fullPath: '/a/tenants/$tenantId/scim'
      preLoaderRoute: typeof AdminATenantsTenantIdTenantScimRouteImport
      parentRoute: typeof AdminATenantsTenantIdTenantRoute
    }
    '/_admin/a/tenants/$tenantId/_tenant/oidc': {
      id: '/_admin/a/tenants/$tenantId/_tenant/oidc'
      path: '/oidc'
      fullPath: '/a/tenants/$tenantId/oidc'
      preLoaderRoute: typeof AdminATenantsTenantIdTenantOidcRouteImport
      parentRoute: typeof AdminATenantsTenantIdTenantRoute
    }
    '/_admin/a/tenants/$tenantId/_tenant/ldap': {
      id: '/_admin/a/tenants/$tenantId/_tenant/ldap'
      path: '/ldap'
      fullPath: '/a/tenants/$tenantId/ldap'
      preLoaderRoute: typeof AdminATenantsTenantIdTenantLdapRouteImport
      parentRoute: typeof AdminATenantsTenantIdTenantRoute
    }
    '/_admin/a/tenants/$tenantId/_tenant/general': {
      id: '/_admin/a/tenants/$tenantId/_tenant/general'
      path: '/general'
      fullPath: '/a/tenants/$tenantId/general'
      preLoaderRoute: typeof AdminATenantsTenantIdTenantGeneralRouteImport
      parentRoute: typeof AdminATenantsTenantIdTenantRoute
    }
    '/_admin/a/tags/$tagId/_tags/outbound-acls': {
      id: '/_admin/a/tags/$tagId/_tags/outbound-acls'
      path: '/outbound-acls'
      fullPath: '/a/tags/$tagId/outbound-acls'
      preLoaderRoute: typeof AdminATagsTagIdTagsOutboundAclsRouteImport
      parentRoute: typeof AdminATagsTagIdTagsRoute
    }
    '/_admin/a/tags/$tagId/_tags/inbound-acls': {
      id: '/_admin/a/tags/$tagId/_tags/inbound-acls'
      path: '/inbound-acls'
      fullPath: '/a/tags/$tagId/inbound-acls'
      preLoaderRoute: typeof AdminATagsTagIdTagsInboundAclsRouteImport
      parentRoute: typeof AdminATagsTagIdTagsRoute
    }
    '/_admin/a/tags/$tagId/_tags/associated': {
      id: '/_admin/a/tags/$tagId/_tags/associated'
      path: '/associated'
      fullPath: '/a/tags/$tagId/associated'
      preLoaderRoute: typeof AdminATagsTagIdTagsAssociatedRouteImport
      parentRoute: typeof AdminATagsTagIdTagsRoute
    }
    '/_admin/a/subnets/$subnetId/_subnet/routers': {
      id: '/_admin/a/subnets/$subnetId/_subnet/routers'
      path: '/routers'
      fullPath: '/a/subnets/$subnetId/routers'
      preLoaderRoute: typeof AdminASubnetsSubnetIdSubnetRoutersRouteImport
      parentRoute: typeof AdminASubnetsSubnetIdSubnetRoute
    }
    '/_admin/a/subnets/$subnetId/_subnet/outbound-acls': {
      id: '/_admin/a/subnets/$subnetId/_subnet/outbound-acls'
      path: '/outbound-acls'
      fullPath: '/a/subnets/$subnetId/outbound-acls'
      preLoaderRoute: typeof AdminASubnetsSubnetIdSubnetOutboundAclsRouteImport
      parentRoute: typeof AdminASubnetsSubnetIdSubnetRoute
    }
    '/_admin/a/subnets/$subnetId/_subnet/inbound-acls': {
      id: '/_admin/a/subnets/$subnetId/_subnet/inbound-acls'
      path: '/inbound-acls'
      fullPath: '/a/subnets/$subnetId/inbound-acls'
      preLoaderRoute: typeof AdminASubnetsSubnetIdSubnetInboundAclsRouteImport
      parentRoute: typeof AdminASubnetsSubnetIdSubnetRoute
    }
    '/_admin/a/rulesets/$rulesetId/_ruleset/rules': {
      id: '/_admin/a/rulesets/$rulesetId/_ruleset/rules'
      path: '/rules'
      fullPath: '/a/rulesets/$rulesetId/rules'
      preLoaderRoute: typeof AdminARulesetsRulesetIdRulesetRulesRouteImport
      parentRoute: typeof AdminARulesetsRulesetIdRulesetRoute
    }
    '/_admin/a/rulesets/$rulesetId/_ruleset/instances': {
      id: '/_admin/a/rulesets/$rulesetId/_ruleset/instances'
      path: '/instances'
      fullPath: '/a/rulesets/$rulesetId/instances'
      preLoaderRoute: typeof AdminARulesetsRulesetIdRulesetInstancesRouteImport
      parentRoute: typeof AdminARulesetsRulesetIdRulesetRoute
    }
    '/_admin/a/plugins/$pluginId/_plugin/rulesets': {
      id: '/_admin/a/plugins/$pluginId/_plugin/rulesets'
      path: '/rulesets'
      fullPath: '/a/plugins/$pluginId/rulesets'
      preLoaderRoute: typeof AdminAPluginsPluginIdPluginRulesetsRouteImport
      parentRoute: typeof AdminAPluginsPluginIdPluginRoute
    }
    '/_admin/a/groups/$groupId/_group/outbound-acls': {
      id: '/_admin/a/groups/$groupId/_group/outbound-acls'
      path: '/outbound-acls'
      fullPath: '/a/groups/$groupId/outbound-acls'
      preLoaderRoute: typeof AdminAGroupsGroupIdGroupOutboundAclsRouteImport
      parentRoute: typeof AdminAGroupsGroupIdGroupRoute
    }
    '/_admin/a/groups/$groupId/_group/inbound-acls': {
      id: '/_admin/a/groups/$groupId/_group/inbound-acls'
      path: '/inbound-acls'
      fullPath: '/a/groups/$groupId/inbound-acls'
      preLoaderRoute: typeof AdminAGroupsGroupIdGroupInboundAclsRouteImport
      parentRoute: typeof AdminAGroupsGroupIdGroupRoute
    }
    '/_admin/a/groups/$groupId/_group/general': {
      id: '/_admin/a/groups/$groupId/_group/general'
      path: '/general'
      fullPath: '/a/groups/$groupId/general'
      preLoaderRoute: typeof AdminAGroupsGroupIdGroupGeneralRouteImport
      parentRoute: typeof AdminAGroupsGroupIdGroupRoute
    }
    '/_admin/a/dns/_dns/extra-records/create-new-domain': {
      id: '/_admin/a/dns/_dns/extra-records/create-new-domain'
      path: '/extra-records/create-new-domain'
      fullPath: '/a/dns/extra-records/create-new-domain'
      preLoaderRoute: typeof AdminADnsDnsExtraRecordsCreateNewDomainRouteImport
      parentRoute: typeof AdminADnsDnsRoute
    }
    '/_admin/a/devices/$deviceId/_device/outbound-acls': {
      id: '/_admin/a/devices/$deviceId/_device/outbound-acls'
      path: '/outbound-acls'
      fullPath: '/a/devices/$deviceId/outbound-acls'
      preLoaderRoute: typeof AdminADevicesDeviceIdDeviceOutboundAclsRouteImport
      parentRoute: typeof AdminADevicesDeviceIdDeviceRoute
    }
    '/_admin/a/devices/$deviceId/_device/inbound-acls': {
      id: '/_admin/a/devices/$deviceId/_device/inbound-acls'
      path: '/inbound-acls'
      fullPath: '/a/devices/$deviceId/inbound-acls'
      preLoaderRoute: typeof AdminADevicesDeviceIdDeviceInboundAclsRouteImport
      parentRoute: typeof AdminADevicesDeviceIdDeviceRoute
    }
    '/_admin/a/devices/$deviceId/_device/general': {
      id: '/_admin/a/devices/$deviceId/_device/general'
      path: '/general'
      fullPath: '/a/devices/$deviceId/general'
      preLoaderRoute: typeof AdminADevicesDeviceIdDeviceGeneralRouteImport
      parentRoute: typeof AdminADevicesDeviceIdDeviceRoute
    }
    '/_admin/a/devices/$deviceId/_device/debug': {
      id: '/_admin/a/devices/$deviceId/_device/debug'
      path: '/debug'
      fullPath: '/a/devices/$deviceId/debug'
      preLoaderRoute: typeof AdminADevicesDeviceIdDeviceDebugRouteImport
      parentRoute: typeof AdminADevicesDeviceIdDeviceRoute
    }
    '/_admin/a/devicegroups/$deviceGroupId/_devicegroups/outbound-acls': {
      id: '/_admin/a/devicegroups/$deviceGroupId/_devicegroups/outbound-acls'
      path: '/outbound-acls'
      fullPath: '/a/devicegroups/$deviceGroupId/outbound-acls'
      preLoaderRoute: typeof AdminADevicegroupsDeviceGroupIdDevicegroupsOutboundAclsRouteImport
      parentRoute: typeof AdminADevicegroupsDeviceGroupIdDevicegroupsRoute
    }
    '/_admin/a/devicegroups/$deviceGroupId/_devicegroups/inbound-acls': {
      id: '/_admin/a/devicegroups/$deviceGroupId/_devicegroups/inbound-acls'
      path: '/inbound-acls'
      fullPath: '/a/devicegroups/$deviceGroupId/inbound-acls'
      preLoaderRoute: typeof AdminADevicegroupsDeviceGroupIdDevicegroupsInboundAclsRouteImport
      parentRoute: typeof AdminADevicegroupsDeviceGroupIdDevicegroupsRoute
    }
    '/_admin/a/devicegroups/$deviceGroupId/_devicegroups/associated': {
      id: '/_admin/a/devicegroups/$deviceGroupId/_devicegroups/associated'
      path: '/associated'
      fullPath: '/a/devicegroups/$deviceGroupId/associated'
      preLoaderRoute: typeof AdminADevicegroupsDeviceGroupIdDevicegroupsAssociatedRouteImport
      parentRoute: typeof AdminADevicegroupsDeviceGroupIdDevicegroupsRoute
    }
    '/_admin/a/settings/_settings/oidc/$providerId/': {
      id: '/_admin/a/settings/_settings/oidc/$providerId/'
      path: '/oidc/$providerId'
      fullPath: '/a/settings/oidc/$providerId/'
      preLoaderRoute: typeof AdminASettingsSettingsOidcProviderIdIndexRouteImport
      parentRoute: typeof AdminASettingsSettingsRoute
    }
  }
}

interface AdminADnsDnsRouteChildren {
  AdminADnsDnsGlobalRoute: typeof AdminADnsDnsGlobalRoute
  AdminADnsDnsSearchDomainsRoute: typeof AdminADnsDnsSearchDomainsRoute
  AdminADnsDnsSplitRoute: typeof AdminADnsDnsSplitRoute
  AdminADnsDnsExtraRecordsCreateNewDomainRoute: typeof AdminADnsDnsExtraRecordsCreateNewDomainRoute
  AdminADnsDnsExtraRecordsIndexRoute: typeof AdminADnsDnsExtraRecordsIndexRoute
}

const AdminADnsDnsRouteChildren: AdminADnsDnsRouteChildren = {
  AdminADnsDnsGlobalRoute: AdminADnsDnsGlobalRoute,
  AdminADnsDnsSearchDomainsRoute: AdminADnsDnsSearchDomainsRoute,
  AdminADnsDnsSplitRoute: AdminADnsDnsSplitRoute,
  AdminADnsDnsExtraRecordsCreateNewDomainRoute:
    AdminADnsDnsExtraRecordsCreateNewDomainRoute,
  AdminADnsDnsExtraRecordsIndexRoute: AdminADnsDnsExtraRecordsIndexRoute,
}

const AdminADnsDnsRouteWithChildren = AdminADnsDnsRoute._addFileChildren(
  AdminADnsDnsRouteChildren,
)

interface AdminAExitnodesExitnodesRouteChildren {
  AdminAExitnodesExitnodesApprovedRoute: typeof AdminAExitnodesExitnodesApprovedRoute
  AdminAExitnodesExitnodesPendingRoute: typeof AdminAExitnodesExitnodesPendingRoute
}

const AdminAExitnodesExitnodesRouteChildren: AdminAExitnodesExitnodesRouteChildren =
  {
    AdminAExitnodesExitnodesApprovedRoute:
      AdminAExitnodesExitnodesApprovedRoute,
    AdminAExitnodesExitnodesPendingRoute: AdminAExitnodesExitnodesPendingRoute,
  }

const AdminAExitnodesExitnodesRouteWithChildren =
  AdminAExitnodesExitnodesRoute._addFileChildren(
    AdminAExitnodesExitnodesRouteChildren,
  )

interface AdminAGroupsGroupsRouteChildren {
  AdminAGroupsGroupsLdapRoute: typeof AdminAGroupsGroupsLdapRoute
  AdminAGroupsGroupsLocalRoute: typeof AdminAGroupsGroupsLocalRoute
  AdminAGroupsGroupsScimRoute: typeof AdminAGroupsGroupsScimRoute
}

const AdminAGroupsGroupsRouteChildren: AdminAGroupsGroupsRouteChildren = {
  AdminAGroupsGroupsLdapRoute: AdminAGroupsGroupsLdapRoute,
  AdminAGroupsGroupsLocalRoute: AdminAGroupsGroupsLocalRoute,
  AdminAGroupsGroupsScimRoute: AdminAGroupsGroupsScimRoute,
}

const AdminAGroupsGroupsRouteWithChildren =
  AdminAGroupsGroupsRoute._addFileChildren(AdminAGroupsGroupsRouteChildren)

interface AdminASettingsSettingsRouteChildren {
  AdminASettingsSettingsEphemeralRoute: typeof AdminASettingsSettingsEphemeralRoute
  AdminASettingsSettingsGeneralRoute: typeof AdminASettingsSettingsGeneralRoute
  AdminASettingsSettingsLocalRoute: typeof AdminASettingsSettingsLocalRoute
  AdminASettingsSettingsOidcIndexRoute: typeof AdminASettingsSettingsOidcIndexRoute
  AdminASettingsSettingsOidcProviderIdIndexRoute: typeof AdminASettingsSettingsOidcProviderIdIndexRoute
}

const AdminASettingsSettingsRouteChildren: AdminASettingsSettingsRouteChildren =
  {
    AdminASettingsSettingsEphemeralRoute: AdminASettingsSettingsEphemeralRoute,
    AdminASettingsSettingsGeneralRoute: AdminASettingsSettingsGeneralRoute,
    AdminASettingsSettingsLocalRoute: AdminASettingsSettingsLocalRoute,
    AdminASettingsSettingsOidcIndexRoute: AdminASettingsSettingsOidcIndexRoute,
    AdminASettingsSettingsOidcProviderIdIndexRoute:
      AdminASettingsSettingsOidcProviderIdIndexRoute,
  }

const AdminASettingsSettingsRouteWithChildren =
  AdminASettingsSettingsRoute._addFileChildren(
    AdminASettingsSettingsRouteChildren,
  )

interface AdminASubnetsSubnetsRouteChildren {
  AdminASubnetsSubnetsApprovedRoute: typeof AdminASubnetsSubnetsApprovedRoute
  AdminASubnetsSubnetsPendingRoute: typeof AdminASubnetsSubnetsPendingRoute
}

const AdminASubnetsSubnetsRouteChildren: AdminASubnetsSubnetsRouteChildren = {
  AdminASubnetsSubnetsApprovedRoute: AdminASubnetsSubnetsApprovedRoute,
  AdminASubnetsSubnetsPendingRoute: AdminASubnetsSubnetsPendingRoute,
}

const AdminASubnetsSubnetsRouteWithChildren =
  AdminASubnetsSubnetsRoute._addFileChildren(AdminASubnetsSubnetsRouteChildren)

interface AdminADevicegroupsDeviceGroupIdDevicegroupsRouteChildren {
  AdminADevicegroupsDeviceGroupIdDevicegroupsAssociatedRoute: typeof AdminADevicegroupsDeviceGroupIdDevicegroupsAssociatedRoute
  AdminADevicegroupsDeviceGroupIdDevicegroupsInboundAclsRoute: typeof AdminADevicegroupsDeviceGroupIdDevicegroupsInboundAclsRoute
  AdminADevicegroupsDeviceGroupIdDevicegroupsOutboundAclsRoute: typeof AdminADevicegroupsDeviceGroupIdDevicegroupsOutboundAclsRoute
}

const AdminADevicegroupsDeviceGroupIdDevicegroupsRouteChildren: AdminADevicegroupsDeviceGroupIdDevicegroupsRouteChildren =
  {
    AdminADevicegroupsDeviceGroupIdDevicegroupsAssociatedRoute:
      AdminADevicegroupsDeviceGroupIdDevicegroupsAssociatedRoute,
    AdminADevicegroupsDeviceGroupIdDevicegroupsInboundAclsRoute:
      AdminADevicegroupsDeviceGroupIdDevicegroupsInboundAclsRoute,
    AdminADevicegroupsDeviceGroupIdDevicegroupsOutboundAclsRoute:
      AdminADevicegroupsDeviceGroupIdDevicegroupsOutboundAclsRoute,
  }

const AdminADevicegroupsDeviceGroupIdDevicegroupsRouteWithChildren =
  AdminADevicegroupsDeviceGroupIdDevicegroupsRoute._addFileChildren(
    AdminADevicegroupsDeviceGroupIdDevicegroupsRouteChildren,
  )

interface AdminADevicesDeviceIdDeviceRouteChildren {
  AdminADevicesDeviceIdDeviceDebugRoute: typeof AdminADevicesDeviceIdDeviceDebugRoute
  AdminADevicesDeviceIdDeviceGeneralRoute: typeof AdminADevicesDeviceIdDeviceGeneralRoute
  AdminADevicesDeviceIdDeviceInboundAclsRoute: typeof AdminADevicesDeviceIdDeviceInboundAclsRoute
  AdminADevicesDeviceIdDeviceOutboundAclsRoute: typeof AdminADevicesDeviceIdDeviceOutboundAclsRoute
}

const AdminADevicesDeviceIdDeviceRouteChildren: AdminADevicesDeviceIdDeviceRouteChildren =
  {
    AdminADevicesDeviceIdDeviceDebugRoute:
      AdminADevicesDeviceIdDeviceDebugRoute,
    AdminADevicesDeviceIdDeviceGeneralRoute:
      AdminADevicesDeviceIdDeviceGeneralRoute,
    AdminADevicesDeviceIdDeviceInboundAclsRoute:
      AdminADevicesDeviceIdDeviceInboundAclsRoute,
    AdminADevicesDeviceIdDeviceOutboundAclsRoute:
      AdminADevicesDeviceIdDeviceOutboundAclsRoute,
  }

const AdminADevicesDeviceIdDeviceRouteWithChildren =
  AdminADevicesDeviceIdDeviceRoute._addFileChildren(
    AdminADevicesDeviceIdDeviceRouteChildren,
  )

interface AdminAGroupsGroupIdGroupRouteChildren {
  AdminAGroupsGroupIdGroupGeneralRoute: typeof AdminAGroupsGroupIdGroupGeneralRoute
  AdminAGroupsGroupIdGroupInboundAclsRoute: typeof AdminAGroupsGroupIdGroupInboundAclsRoute
  AdminAGroupsGroupIdGroupOutboundAclsRoute: typeof AdminAGroupsGroupIdGroupOutboundAclsRoute
}

const AdminAGroupsGroupIdGroupRouteChildren: AdminAGroupsGroupIdGroupRouteChildren =
  {
    AdminAGroupsGroupIdGroupGeneralRoute: AdminAGroupsGroupIdGroupGeneralRoute,
    AdminAGroupsGroupIdGroupInboundAclsRoute:
      AdminAGroupsGroupIdGroupInboundAclsRoute,
    AdminAGroupsGroupIdGroupOutboundAclsRoute:
      AdminAGroupsGroupIdGroupOutboundAclsRoute,
  }

const AdminAGroupsGroupIdGroupRouteWithChildren =
  AdminAGroupsGroupIdGroupRoute._addFileChildren(
    AdminAGroupsGroupIdGroupRouteChildren,
  )

interface AdminAPluginsPluginIdPluginRouteChildren {
  AdminAPluginsPluginIdPluginRulesetsRoute: typeof AdminAPluginsPluginIdPluginRulesetsRoute
}

const AdminAPluginsPluginIdPluginRouteChildren: AdminAPluginsPluginIdPluginRouteChildren =
  {
    AdminAPluginsPluginIdPluginRulesetsRoute:
      AdminAPluginsPluginIdPluginRulesetsRoute,
  }

const AdminAPluginsPluginIdPluginRouteWithChildren =
  AdminAPluginsPluginIdPluginRoute._addFileChildren(
    AdminAPluginsPluginIdPluginRouteChildren,
  )

interface AdminARulesetsRulesetIdRulesetRouteChildren {
  AdminARulesetsRulesetIdRulesetInstancesRoute: typeof AdminARulesetsRulesetIdRulesetInstancesRoute
  AdminARulesetsRulesetIdRulesetRulesRoute: typeof AdminARulesetsRulesetIdRulesetRulesRoute
}

const AdminARulesetsRulesetIdRulesetRouteChildren: AdminARulesetsRulesetIdRulesetRouteChildren =
  {
    AdminARulesetsRulesetIdRulesetInstancesRoute:
      AdminARulesetsRulesetIdRulesetInstancesRoute,
    AdminARulesetsRulesetIdRulesetRulesRoute:
      AdminARulesetsRulesetIdRulesetRulesRoute,
  }

const AdminARulesetsRulesetIdRulesetRouteWithChildren =
  AdminARulesetsRulesetIdRulesetRoute._addFileChildren(
    AdminARulesetsRulesetIdRulesetRouteChildren,
  )

interface AdminASubnetsSubnetIdSubnetRouteChildren {
  AdminASubnetsSubnetIdSubnetInboundAclsRoute: typeof AdminASubnetsSubnetIdSubnetInboundAclsRoute
  AdminASubnetsSubnetIdSubnetOutboundAclsRoute: typeof AdminASubnetsSubnetIdSubnetOutboundAclsRoute
  AdminASubnetsSubnetIdSubnetRoutersRoute: typeof AdminASubnetsSubnetIdSubnetRoutersRoute
}

const AdminASubnetsSubnetIdSubnetRouteChildren: AdminASubnetsSubnetIdSubnetRouteChildren =
  {
    AdminASubnetsSubnetIdSubnetInboundAclsRoute:
      AdminASubnetsSubnetIdSubnetInboundAclsRoute,
    AdminASubnetsSubnetIdSubnetOutboundAclsRoute:
      AdminASubnetsSubnetIdSubnetOutboundAclsRoute,
    AdminASubnetsSubnetIdSubnetRoutersRoute:
      AdminASubnetsSubnetIdSubnetRoutersRoute,
  }

const AdminASubnetsSubnetIdSubnetRouteWithChildren =
  AdminASubnetsSubnetIdSubnetRoute._addFileChildren(
    AdminASubnetsSubnetIdSubnetRouteChildren,
  )

interface AdminATagsTagIdTagsRouteChildren {
  AdminATagsTagIdTagsAssociatedRoute: typeof AdminATagsTagIdTagsAssociatedRoute
  AdminATagsTagIdTagsInboundAclsRoute: typeof AdminATagsTagIdTagsInboundAclsRoute
  AdminATagsTagIdTagsOutboundAclsRoute: typeof AdminATagsTagIdTagsOutboundAclsRoute
}

const AdminATagsTagIdTagsRouteChildren: AdminATagsTagIdTagsRouteChildren = {
  AdminATagsTagIdTagsAssociatedRoute: AdminATagsTagIdTagsAssociatedRoute,
  AdminATagsTagIdTagsInboundAclsRoute: AdminATagsTagIdTagsInboundAclsRoute,
  AdminATagsTagIdTagsOutboundAclsRoute: AdminATagsTagIdTagsOutboundAclsRoute,
}

const AdminATagsTagIdTagsRouteWithChildren =
  AdminATagsTagIdTagsRoute._addFileChildren(AdminATagsTagIdTagsRouteChildren)

interface AdminATenantsTenantIdTenantRouteChildren {
  AdminATenantsTenantIdTenantGeneralRoute: typeof AdminATenantsTenantIdTenantGeneralRoute
  AdminATenantsTenantIdTenantLdapRoute: typeof AdminATenantsTenantIdTenantLdapRoute
  AdminATenantsTenantIdTenantOidcRoute: typeof AdminATenantsTenantIdTenantOidcRoute
  AdminATenantsTenantIdTenantScimRoute: typeof AdminATenantsTenantIdTenantScimRoute
  AdminATenantsTenantIdTenantSearchDomainRoute: typeof AdminATenantsTenantIdTenantSearchDomainRoute
  AdminATenantsTenantIdTenantSplitDnsRoute: typeof AdminATenantsTenantIdTenantSplitDnsRoute
}

const AdminATenantsTenantIdTenantRouteChildren: AdminATenantsTenantIdTenantRouteChildren =
  {
    AdminATenantsTenantIdTenantGeneralRoute:
      AdminATenantsTenantIdTenantGeneralRoute,
    AdminATenantsTenantIdTenantLdapRoute: AdminATenantsTenantIdTenantLdapRoute,
    AdminATenantsTenantIdTenantOidcRoute: AdminATenantsTenantIdTenantOidcRoute,
    AdminATenantsTenantIdTenantScimRoute: AdminATenantsTenantIdTenantScimRoute,
    AdminATenantsTenantIdTenantSearchDomainRoute:
      AdminATenantsTenantIdTenantSearchDomainRoute,
    AdminATenantsTenantIdTenantSplitDnsRoute:
      AdminATenantsTenantIdTenantSplitDnsRoute,
  }

const AdminATenantsTenantIdTenantRouteWithChildren =
  AdminATenantsTenantIdTenantRoute._addFileChildren(
    AdminATenantsTenantIdTenantRouteChildren,
  )

interface AdminAUsersUserIdUserRouteChildren {
  AdminAUsersUserIdUserAccessHistoryRoute: typeof AdminAUsersUserIdUserAccessHistoryRoute
  AdminAUsersUserIdUserGeneralRoute: typeof AdminAUsersUserIdUserGeneralRoute
  AdminAUsersUserIdUserInvitationRoute: typeof AdminAUsersUserIdUserInvitationRoute
}

const AdminAUsersUserIdUserRouteChildren: AdminAUsersUserIdUserRouteChildren = {
  AdminAUsersUserIdUserAccessHistoryRoute:
    AdminAUsersUserIdUserAccessHistoryRoute,
  AdminAUsersUserIdUserGeneralRoute: AdminAUsersUserIdUserGeneralRoute,
  AdminAUsersUserIdUserInvitationRoute: AdminAUsersUserIdUserInvitationRoute,
}

const AdminAUsersUserIdUserRouteWithChildren =
  AdminAUsersUserIdUserRoute._addFileChildren(
    AdminAUsersUserIdUserRouteChildren,
  )

interface AdminLazyRouteChildren {
  AdminADevicesCreateServerRoute: typeof AdminADevicesCreateServerRoute
  AdminADnsDnsRoute: typeof AdminADnsDnsRouteWithChildren
  AdminAExitnodesExitnodesRoute: typeof AdminAExitnodesExitnodesRouteWithChildren
  AdminAGroupsGroupsRoute: typeof AdminAGroupsGroupsRouteWithChildren
  AdminAGroupsCreateLocalRoute: typeof AdminAGroupsCreateLocalRoute
  AdminASettingsSettingsRoute: typeof AdminASettingsSettingsRouteWithChildren
  AdminASubnetsSubnetsRoute: typeof AdminASubnetsSubnetsRouteWithChildren
  AdminATenantsCreateRoute: typeof AdminATenantsCreateRoute
  AdminAUsersInviteRoute: typeof AdminAUsersInviteRoute
  AdminAAccessVisualizationIndexRoute: typeof AdminAAccessVisualizationIndexRoute
  AdminAAccountsIndexRoute: typeof AdminAAccountsIndexRoute
  AdminAChangelogIndexRoute: typeof AdminAChangelogIndexRoute
  AdminADashboardIndexRoute: typeof AdminADashboardIndexRoute
  AdminADevicegroupsIndexRoute: typeof AdminADevicegroupsIndexRoute
  AdminADevicesIndexRoute: typeof AdminADevicesIndexRoute
  AdminADnsIndexRoute: typeof AdminADnsIndexRoute
  AdminAExitnodesIndexRoute: typeof AdminAExitnodesIndexRoute
  AdminAGroupsIndexRoute: typeof AdminAGroupsIndexRoute
  AdminALogsIndexRoute: typeof AdminALogsIndexRoute
  AdminAPluginsIndexRoute: typeof AdminAPluginsIndexRoute
  AdminAPreauthkeysIndexRoute: typeof AdminAPreauthkeysIndexRoute
  AdminAProfileIndexRoute: typeof AdminAProfileIndexRoute
  AdminARulesetsIndexRoute: typeof AdminARulesetsIndexRoute
  AdminASettingsIndexRoute: typeof AdminASettingsIndexRoute
  AdminASubnetsIndexRoute: typeof AdminASubnetsIndexRoute
  AdminATagsIndexRoute: typeof AdminATagsIndexRoute
  AdminATenantsIndexRoute: typeof AdminATenantsIndexRoute
  AdminAUsersIndexRoute: typeof AdminAUsersIndexRoute
  AdminADevicegroupsDeviceGroupIdDevicegroupsRoute: typeof AdminADevicegroupsDeviceGroupIdDevicegroupsRouteWithChildren
  AdminADevicesDeviceIdDeviceRoute: typeof AdminADevicesDeviceIdDeviceRouteWithChildren
  AdminAGroupsGroupIdGroupRoute: typeof AdminAGroupsGroupIdGroupRouteWithChildren
  AdminAPluginsPluginIdPluginRoute: typeof AdminAPluginsPluginIdPluginRouteWithChildren
  AdminARulesetsRulesetIdRulesetRoute: typeof AdminARulesetsRulesetIdRulesetRouteWithChildren
  AdminASubnetsSubnetIdSubnetRoute: typeof AdminASubnetsSubnetIdSubnetRouteWithChildren
  AdminATagsTagIdTagsRoute: typeof AdminATagsTagIdTagsRouteWithChildren
  AdminATenantsTenantIdTenantRoute: typeof AdminATenantsTenantIdTenantRouteWithChildren
  AdminATenantsTenantIdDeletePreviewRoute: typeof AdminATenantsTenantIdDeletePreviewRoute
  AdminAUsersUserIdUserRoute: typeof AdminAUsersUserIdUserRouteWithChildren
  AdminAPluginsPluginIdIndexRoute: typeof AdminAPluginsPluginIdIndexRoute
}

const AdminLazyRouteChildren: AdminLazyRouteChildren = {
  AdminADevicesCreateServerRoute: AdminADevicesCreateServerRoute,
  AdminADnsDnsRoute: AdminADnsDnsRouteWithChildren,
  AdminAExitnodesExitnodesRoute: AdminAExitnodesExitnodesRouteWithChildren,
  AdminAGroupsGroupsRoute: AdminAGroupsGroupsRouteWithChildren,
  AdminAGroupsCreateLocalRoute: AdminAGroupsCreateLocalRoute,
  AdminASettingsSettingsRoute: AdminASettingsSettingsRouteWithChildren,
  AdminASubnetsSubnetsRoute: AdminASubnetsSubnetsRouteWithChildren,
  AdminATenantsCreateRoute: AdminATenantsCreateRoute,
  AdminAUsersInviteRoute: AdminAUsersInviteRoute,
  AdminAAccessVisualizationIndexRoute: AdminAAccessVisualizationIndexRoute,
  AdminAAccountsIndexRoute: AdminAAccountsIndexRoute,
  AdminAChangelogIndexRoute: AdminAChangelogIndexRoute,
  AdminADashboardIndexRoute: AdminADashboardIndexRoute,
  AdminADevicegroupsIndexRoute: AdminADevicegroupsIndexRoute,
  AdminADevicesIndexRoute: AdminADevicesIndexRoute,
  AdminADnsIndexRoute: AdminADnsIndexRoute,
  AdminAExitnodesIndexRoute: AdminAExitnodesIndexRoute,
  AdminAGroupsIndexRoute: AdminAGroupsIndexRoute,
  AdminALogsIndexRoute: AdminALogsIndexRoute,
  AdminAPluginsIndexRoute: AdminAPluginsIndexRoute,
  AdminAPreauthkeysIndexRoute: AdminAPreauthkeysIndexRoute,
  AdminAProfileIndexRoute: AdminAProfileIndexRoute,
  AdminARulesetsIndexRoute: AdminARulesetsIndexRoute,
  AdminASettingsIndexRoute: AdminASettingsIndexRoute,
  AdminASubnetsIndexRoute: AdminASubnetsIndexRoute,
  AdminATagsIndexRoute: AdminATagsIndexRoute,
  AdminATenantsIndexRoute: AdminATenantsIndexRoute,
  AdminAUsersIndexRoute: AdminAUsersIndexRoute,
  AdminADevicegroupsDeviceGroupIdDevicegroupsRoute:
    AdminADevicegroupsDeviceGroupIdDevicegroupsRouteWithChildren,
  AdminADevicesDeviceIdDeviceRoute:
    AdminADevicesDeviceIdDeviceRouteWithChildren,
  AdminAGroupsGroupIdGroupRoute: AdminAGroupsGroupIdGroupRouteWithChildren,
  AdminAPluginsPluginIdPluginRoute:
    AdminAPluginsPluginIdPluginRouteWithChildren,
  AdminARulesetsRulesetIdRulesetRoute:
    AdminARulesetsRulesetIdRulesetRouteWithChildren,
  AdminASubnetsSubnetIdSubnetRoute:
    AdminASubnetsSubnetIdSubnetRouteWithChildren,
  AdminATagsTagIdTagsRoute: AdminATagsTagIdTagsRouteWithChildren,
  AdminATenantsTenantIdTenantRoute:
    AdminATenantsTenantIdTenantRouteWithChildren,
  AdminATenantsTenantIdDeletePreviewRoute:
    AdminATenantsTenantIdDeletePreviewRoute,
  AdminAUsersUserIdUserRoute: AdminAUsersUserIdUserRouteWithChildren,
  AdminAPluginsPluginIdIndexRoute: AdminAPluginsPluginIdIndexRoute,
}

const AdminLazyRouteWithChildren = AdminLazyRoute._addFileChildren(
  AdminLazyRouteChildren,
)

interface StaticLazyRouteChildren {
  StaticSLoginDisabledRoute: typeof StaticSLoginDisabledRoute
  StaticSLoginInvalidCsrfRoute: typeof StaticSLoginInvalidCsrfRoute
  StaticSLoginOutdatedRoute: typeof StaticSLoginOutdatedRoute
  StaticSLoginServerErrorRoute: typeof StaticSLoginServerErrorRoute
}

const StaticLazyRouteChildren: StaticLazyRouteChildren = {
  StaticSLoginDisabledRoute: StaticSLoginDisabledRoute,
  StaticSLoginInvalidCsrfRoute: StaticSLoginInvalidCsrfRoute,
  StaticSLoginOutdatedRoute: StaticSLoginOutdatedRoute,
  StaticSLoginServerErrorRoute: StaticSLoginServerErrorRoute,
}

const StaticLazyRouteWithChildren = StaticLazyRoute._addFileChildren(
  StaticLazyRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminLazyRoute: AdminLazyRouteWithChildren,
  StaticLazyRoute: StaticLazyRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
